import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { AgencyService } from "src/app/services/agency/agency.service";
import { EsocService } from "src/app/services/e-soc/esoc.service";
import { CompanyService } from "../services/company/company.service";
import {
  Agency,
  AgencyFiltersOptions,
  agencyLevelValues,
  agencyStatusValues,
  status,
  statusValues,
  DiagnosisGroupOptions,
  AgencyListingRows,
  defaultSelectedAgencyRows,
  EDocsFile,
} from "src/app/models/agency";
import { MessageHandlerService } from "src/app/services/message-handler.service";
import { UserDataManager } from "src/app/user/UserDataManager";
import { User, UserStatus } from "src/app/models/user";
import { Table } from "primeng/table";
import { ConfirmationService, PrimeNGConfig, SelectItem } from "primeng/api";
import { ProgressBarService } from "src/app/services/progress-bar.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Observable, Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import { countries } from "../models/country-data";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { FileUpload } from "primeng/fileupload";
import {
  USER_DEVICES_REPORT_FILE_NAME,
  ERROR_WARNING_REPORT_FILE_NAME,
  DATE_PICKER_FORMAT,
  DATE_PICKER_PLACEHOLDER,
  DEFAULT_SEARCH_MIN_CHARACTER,
  EXCEL_EXTENSION,
  EXCEL_TYPE,
  RoleID,
  OnlySuperAdminAllowedRoles,
  dateFormatStartWithYear,
  dateFormatStartWithYearWithOutDashes,
  portalFeatureValues,
  rowsPerPageOptions,
  CURRENT_RELEASE_VERSION,
  RELOAD_PAGE_AFTER_RELEASE,
  EMAIL_ALREADY_REGISTERED_AGENCY,
  QUESTIONAIR_TYPE_ERROR,
  QUESTIONAIR_TYPE_WARN,
  QUESTIONAIR_TYPE_WARNING,
  IMPACT,
  ERROR_WARNING_DIAGNOSTIC_GROUP_MAPPING,
  USER_STATUS_REPORT_FILE_NAME,
  USER_STATUS_FILE_NAME,
  RoleNames,
  USER_STATUS_REPORT_FILE_TITLE,
  DEFAULT_AGENCY_EDOC_LINK_EXPIRATION_TIME,
  CLINICIAN_CHANGE_REPORT_NAME,
  CLINICIAN_SUGGESTION_CALCULATION_REPORT_NAME,
  appSettings,
  appSettingsCheckbox,
  NO_OF_RECORDS_PER_PAGE,
  REPORT_TIME_ZONE,
  IO_ALERT_REPORT_NAME,
  ALERT_TYPE_DATE_RANGE_SELECTION,
  ALLOWED_SOC_PACKET_FILE_FORMATS,
  SOC_PACKET_FILE_FORMAT_ERROR,
  TEMPLATE_INFO,
  AGENCY_TEMPLATE_DEFAULT_EMAIL_BODIES,
  AGENCY_TEMPLATE_DEFAULT_SMS,
  BRANCH_CODES_PATTERN,
} from "../common/Constants";
import { endOfToday } from "../common/calendar-max-date.util";
import { Paginator } from "primeng/paginator";
import { PortalFeatures } from "../models/agency";
import { SidenavService } from "../core/sidebar/sidenav.service";
import { UtilService } from "../services/util/util.service";
import { DatePipe } from "@angular/common";
import { Workbook } from "exceljs";
import * as fs from "file-saver";
import { select, Store } from "@ngrx/store";
import { addAgency } from "../store/agency.actions";
import { AppState } from "../store/reducers";
import { LocalStorageService } from "../services/local-storage.service";
import { ActivatedRoute } from "@angular/router";
import { HttpEventType } from "@angular/common/http";
import { Dropdown } from "primeng/dropdown";
import { groupBy } from "lodash-es";
import {CompanyUserRegistrationType, CompanyUserRegistrationTypeEnum, nonMdmCustomerOptions, NonMDMCustomerEnum} from "../models/company";
import { AppLinkService } from "../services/app-link/app-link.service";
import { AppLink } from "../models/app-link";
import {uniqueBranchCodesValidator, validateDateRange} from "../services/util/helper.function";
import { HosAddendumService } from "../services/hos-addendum/hos-addendum.service";

@Component({
  selector: "app-agencies",
  templateUrl: "./agencies.component.html",
  styleUrls: ["./agencies.component.scss"],
})
export class AgenciesComponent implements OnInit, OnDestroy, AfterViewInit {
  agencies: Agency[] = [];
  display = false;
  addAgencyForm: FormGroup;
  portalFeatures: PortalFeatures[] = portalFeatureValues;
  currentUser: User;
  selectedAgenciesToExport: Agency[] = [];
  searchAgency: string = "";
  totalAgencies: number = 0;
  agencyToUpdate: Agency;
  agencyLevel: any[] = [];
  currentImage: any;
  statusEnum = status;
  showEditForm: boolean = false;
  selectedIndex: any;
  subscriptions: Subscription[] = [];
  currentAgencyRole: { agency: string; role: string };
  pageNo: number = 0;
  noOfAgenciesPerRow: number = NO_OF_RECORDS_PER_PAGE;
  rowsPerPageOptions: number[] = rowsPerPageOptions;
  isChangingPage: boolean = false;
  loading: boolean = false;
  agencyAdminUser = RoleID.AgencyAdmin;
  iohSuperAdmin = RoleID.Admin;
  iohAdmin = RoleID.iohAdmin;
  companyAdmin = RoleID.companyAdmin;
  countries = countries;
  agencyStatusFilterOptions: SelectItem[] = agencyStatusValues;
  selectedAgencyStatus;
  agencyLevelFilterOptions: SelectItem[] = agencyLevelValues;
  selectedAgencyLevel;
  agencyLevelFilter: string = "";
  agencyStatusFilter: string = "";
  showInvalidSMSTemplateError: boolean = false;
  showInvalidEmailTemplateError: boolean = false;
  TEMPLATE_INFO = TEMPLATE_INFO;
  AgencyFiltersOptions = AgencyFiltersOptions;
  @ViewChild("paginator") paginator: Paginator;
  @ViewChild("fileUpload", { static: false }) fileUpload: FileUpload;
  @ViewChild("dt") table: Table;
  @ViewChild("reportDropdown") reportDropdown: Dropdown;
  defaultSearchMinCharacter = DEFAULT_SEARCH_MIN_CHARACTER;
  diagnosisGroupOptions = DiagnosisGroupOptions;
  selectedDiagnosisGroups: string[] = [];
  // Automated Merged Document Delivery
  deliveryDestinations: any[] = [];
  /**
   * An agency has exactly one addendum email and one addendum fax. Held as a list so the template
   * describes a slot once rather than twice, not because more than one of each is allowed.
   */
  readonly deliveryChannels: {
    key: "EMAIL" | "FAX";
    label: string;
    icon: string;
    placeholder: string;
  }[] = [
    {
      key: "EMAIL",
      label: "Addendum Email",
      icon: "pi pi-envelope",
      placeholder: "records@agency.com",
    },
    {
      key: "FAX",
      label: "Addendum Fax",
      icon: "pi pi-print",
      placeholder: "(555) 123-4567",
    },
  ];
  loadingDeliveryDestinations: boolean = false;
  /** Whether the open agency's company has HOS Addendum on, so these settings apply to it at all. */
  deliverySettingsAvailable: boolean = false;
  /**
   * The settings could not be asked for - the service was down or unreachable. Said so, with a way to
   * try again: the section used to disappear without a word, which read as the feature being missing.
   */
  deliverySettingsUnreachable: boolean = false;
  addDestinationDialogVisible: boolean = false;
  verifyDestinationDialogVisible: boolean = false;
  selectedDestination: any = null;
  // Upper case, because that is what the API accepts and what is stored. The DTO validates with
  // @IsEnum(EDeliveryChannel) where the members are 'EMAIL' and 'FAX', behind a global ValidationPipe,
  // so a lower-case value is rejected with a 400 before the service is reached - which made every
  // Add Destination call fail and left the whole screen unusable.
  destinationChannel: 'EMAIL' | 'FAX' = 'EMAIL';
  destinationValue: string = '';
  destinationChannelOptions: { label: string; value: string }[] = [
    { label: 'Email', value: 'EMAIL' },
    { label: 'Fax', value: 'FAX' },
  ];
  verificationCodeInput: string = '';
  savingDestination: boolean = false;
  requestingCode: boolean = false;
  verifyingCode: boolean = false;
  togglingDestinationId: string | null = null;
  requestCodeButtonLabel: string = 'Send Verification Code';
  companyPayload = [];
  companies = [];
  filteredCompanies: any[] = [];
  datePickerFormat = DATE_PICKER_FORMAT;
  datePickerPlaceholder = DATE_PICKER_PLACEHOLDER;
  rangeDates: Date[] = null;
  dateRangeToExportAgencyData = null;
  disableDiagnosisGroups: boolean = true;
  agenciesAllowed: any[] = [];
  exportReportValues = [
    { label: "Errors & Warnings", icon: "pi pi-download", value: "Errors & Warnings" },
    { label: "Users & Devices", icon: "pi pi-download", value: "Users & Devices" },
    { label: "Users Status", icon: "pi pi-download", value: "User Status" },
    { label: "User Activation", icon: "pi pi-download", value: "User Activation" },
    { label: "Warnings Report", icon: "pi pi-download", value: "Warnings"},
    { label: "Popup Report", icon: "pi pi-download", value: "Popup"},
    { label: "OASIS Summary Report", icon: "pi pi-download", value: "Oasis"},
    { label: "Agency Comparison Report", icon: "pi pi-download", value: "Comparison"},
    { label: "Clinician Analysis Report", icon: "pi pi-download", value: "CliAnalysisReport"}
  ];
  clockUnitOptions = [
    { label: "Days", value: "days" },
    { label: "Minutes", value: "minutes" },
  ];
  componentLocalStorageKey = "agencyState";
  exportReportHeaders;
  workbook: Workbook;
  worksheet;
  agencyStatus = statusValues;
  COMPANY_ADMIN = RoleID.companyAdmin;
  agencies$: Observable<string[]>;
  selectedRows: any[] = defaultSelectedAgencyRows;
  visibleRows: any[] = AgencyListingRows;
  selectedAgencies = [];
  selectedAgencyIdFromParams = "";
  selectAll = false;
  appSettingCheckboxes = appSettingsCheckbox;
  registrationTypeFilterOptions: SelectItem[] = CompanyUserRegistrationType;
  nonMdmCustomerOptions: SelectItem[] = nonMdmCustomerOptions;
  NonMDMCustomerEnum = NonMDMCustomerEnum;
  loginWithPCIDenabled;
  maxDate: Date = endOfToday();
  appLinks: AppLink[] = [];
  appLinkOptions: SelectItem[] = [];
  selectedAppLinkId: string | number | null = null;
  isFetchingAppLinks = false;
  isSendingAppLinkEmail = false;
  private nonMdmCustomerChangeSub?: Subscription;
  isSuperAdminOnlyRole = false;

  eDocsFile: EDocsFile | null = null;
  eDocsFileName: string = '';
  patientSigningDocuments: any[] = [];
  isSigningDocUploading: boolean = false;
  signingDocUploadValue: number = 0;
  signingDocUploadProgressBar: boolean = false;
  eDocsFileUploadedAt: string = '';
  showEDocsDragAndDrop: boolean = true;
  showEDocsFileInfo: boolean = false;
  eDocsUploadProgressBar: boolean = false;
  eDocsUploadValue: number = 0;
  isEDocsUploading: boolean = false;
  eDocsFileDeleted: boolean = false;
  private eDocsUploadIntervalId: any = null;

  constructor(
    private readonly agencyService: AgencyService,
    private readonly companyService: CompanyService,
    private readonly messageHandlerService: MessageHandlerService,
    private readonly primengConfig: PrimeNGConfig,
    private readonly userDataManager: UserDataManager,
    private readonly progressBarService: ProgressBarService,
    private readonly formBuilder: FormBuilder,
    private readonly confirmationService: ConfirmationService,
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
    private readonly sideNavService: SidenavService,
    private readonly utilService: UtilService,
    private readonly datePipe: DatePipe,
    private readonly store: Store<AppState>,
    private readonly localStorageService: LocalStorageService,
    private readonly route: ActivatedRoute,
    private readonly appLinkService: AppLinkService,
    private readonly esocService: EsocService,
    private readonly hosAddendumService: HosAddendumService,
  ) {
    this.agencies$ = this.store.pipe(select((state) => state.agencyState.agencies));

    this.agencyLevel = [
      // Use app-root-relative asset paths so they work in any template context
      { icon: "assets/images/badge-gold.svg", value: "Gold" },
      { icon: "assets/images/badge-silver.svg", value: "Silver" },
      { icon: "assets/images/badge-bronze.svg", value: "Bronze" },
    ];
    this.matIconRegistry.addSvgIcon("status", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/images/active-inactive.svg"));
    this.matIconRegistry.addSvgIcon("delete", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/images/delete-item.svg"));
  }

  ngOnInit(): void {
    this.getAgencyIdFromParams();
    this.getReleaseVersion();
    this.getUserProfile();
    this.getDataFromLocalStorage();
    this.isAgencyAdmin();
    this.getCurrentAgencyRole();
    if (this.currentUser.is_super_admin || this.currentUser.is_IOH_admin) {
      this.getCompanies();
      this.exportReportValues.push({ label: CLINICIAN_CHANGE_REPORT_NAME, icon: "pi pi-download", value: CLINICIAN_CHANGE_REPORT_NAME });
      this.exportReportValues.push({ label: CLINICIAN_SUGGESTION_CALCULATION_REPORT_NAME, icon: "pi pi-download", value: CLINICIAN_SUGGESTION_CALCULATION_REPORT_NAME });
      this.exportReportValues.push({ label: IO_ALERT_REPORT_NAME, icon: "pi pi-download", value: IO_ALERT_REPORT_NAME })
    }
    this.createAgencyForm();
    this.getSelectedRows();
  }

  ngAfterViewInit(): void {
    // Initialize dropdown label preservation
    this.initializeDropdownLabelPreservation();
  }

  onGenerateReportSelect(event) {
    if (event.value == "Users & Devices") {
      this.onExportUserInfo();
    } else if (event.value == "Errors & Warnings") {
      this.onExportData();
    } else if (event.value == "User Status") {
      this.onExportUserStatusReport();
    } else if (event.value == "User Activation") {
      this.onExportUserActivationReport();
    } else if (event.value == CLINICIAN_CHANGE_REPORT_NAME) {
      this.onExportUserActivityReport();
    } else if (event.value == CLINICIAN_SUGGESTION_CALCULATION_REPORT_NAME) {
      this.onExportClinicianSuggestionCalculationReport();
    }else if(event.value == IO_ALERT_REPORT_NAME) {
      this.onExportIOAlertReport();
    }else if (event.value == "Warnings"){
      this.downloadWarningsReport();
    }else if(event.value == "Popup"){
      this.downloadPopupReport();
    }else if(event.value == "Oasis"){
      this.downloadOasisReport();
    }else if(event.value == "Comparison"){
      this.downloadAgencyComparisonReport()
    }else if(event.value == "CliAnalysisReport"){
      this.downloadClinicianAnalysisReport()
    }

    // Reset dropdown to maintain "Generate Reports" label
    this.resetDropdownDisplay();
  }

  getDataFromLocalStorage() {
    const agencyState = JSON.parse(this.localStorageService.get(this.componentLocalStorageKey));
    this.selectedAgencyLevel = agencyState?.selectedAgencyLevel ? agencyState?.selectedAgencyLevel : "";
    this.selectedAgencyStatus = agencyState?.selectedAgencyStatus ? agencyState?.selectedAgencyStatus : this.agencyStatusFilterOptions[1].value;
    this.agencyStatusFilter = this.selectedAgencyStatus;
    this.agencyLevelFilter = this.selectedAgencyLevel;

    this.prePopulatePerPage();
  }

  prePopulateDate() {
    const global = JSON.parse(this.localStorageService.get("globalDates"));
    if (global) {
      this.rangeDates = [new Date(global.startDate), global.endDate? new Date(global.endDate): new Date()];
      this.setDatesForExport();
    }
  }

  prePopulatePerPage() {
    const global = JSON.parse(this.localStorageService.get("globalPageLimit"));
    if (global) {
      this.noOfAgenciesPerRow = global.perPage;
    }
  }

  getAgencyIdFromParams() {
    this.route.params.subscribe((params) => {
      this.selectedAgencyIdFromParams = params["id"];
    });
  }
  getAgencyValuesFromStore() {
    if (this.selectAll) {
      const agencyIds = this.agencies.map((agency) => {
        this.selectedAgenciesToExport.push(agency);
        return agency.id;
      });
      this.selectedAgencies = [...new Set(this.selectedAgencies.concat(agencyIds))];

      this.store.dispatch(addAgency({ agencies: this.selectedAgencies }));
    } else {
      this.subscriptions.push(
        this.agencies$.subscribe((storeAgencies) => {
          this.selectedAgenciesToExport = [];
          this.selectedAgencies = [];
          if (storeAgencies.length) {
            storeAgencies.forEach((storeAgency) => {
              const selectedAgencyMatch = this.agencies.find((agency) => agency.id == storeAgency);
              this.selectedAgencies.push(storeAgency);
              if (selectedAgencyMatch) {
                this.selectedAgenciesToExport.push(selectedAgencyMatch);
                this.prePopulateDate();
              }
            });
          }
        }),
      );
    }
  }

  onRowSelect() {
    const newValue: string[] = this.selectedAgenciesToExport.map((agency) => {
      return agency?.id;
    });

    this.selectedAgencies = [...new Set(newValue.concat(this.selectedAgencies))];
    this.store.dispatch(addAgency({ agencies: this.selectedAgencies }));
    this.resetFilters();
    this.prePopulateDate();
  }

  onRowUnSelect(event) {
    const index = this.selectedAgencies.indexOf(event?.data?.id);

    if (index !== -1) {
      this.selectedAgencies.splice(index, 1);
    }

    this.store.dispatch(addAgency({ agencies: this.selectedAgencies }));
    this.resetFilters();
    this.prePopulateDate();
  }

  onHeaderCheckboxToggle(event) {
    if (event?.checked) {
      this.selectAll = true;
      this.pageNo = 0;
      this.rowsPerPageOptions = [10, 20, 30, this.totalAgencies].sort();
      this.noOfAgenciesPerRow = this.totalAgencies;
      this.getAgencies();
    } else {
      this.selectAll = false;
      this.pageNo = 0;
      this.rowsPerPageOptions = [10, 20, 30].sort();
      this.noOfAgenciesPerRow = 10;
      this.selectedAgencies = [];
      this.selectedAgenciesToExport = [];
      this.store.dispatch(addAgency({ agencies: [] }));
      this.getAgencies();
    }
    // const agenciesIds = this.agencies.map((agency) => agency?.id);
    // if (event?.checked) {
    //   this.selectedAgencies = [...new Set(this.selectedAgencies.concat(agenciesIds))];
    // } else {
    //   agenciesIds.forEach((agenciesId) => {
    //     const index = this.selectedAgencies.indexOf(agenciesId);

    //     if (index !== -1) {
    //       this.selectedAgencies.splice(index, 1);
    //     }
    //   });
    // }

    // this.store.dispatch(addAgency({ agencies: this.selectedAgencies }));
    this.resetFilters();
    this.prePopulateDate();
  }

  resetFilters() {
    this.localStorageService.remove("patientState");
    this.localStorageService.remove("visitState");
    this.localStorageService.remove("companyState");
  }

  onSelectCompany(event) {
    if (event.value) {
      this.confirmationService.confirm({
        message: "Please confirm if you wanted to select this Company",
        header: "Confirm Company?",
        icon: "pi pi-cog",
        acceptLabel: "Confirm",
        rejectLabel: "Cancel",
        accept: () => {},
        reject: () => {
          this.addAgencyForm.get("companyId").patchValue("");
        },
      });
    }
  }

  companyRequired() {
    this.addAgencyForm.get("companyId").setValidators(Validators.required);
  }

  removeCompany() {
    this.confirmationService.confirm({
      message: "Please confirm if you wanted to delete this Company",
      header: "Delete Company?",
      icon: "pi pi-trash",
      acceptLabel: "Delete",
      rejectLabel: "Cancel",
      acceptButtonStyleClass: "btn-delete",
      accept: () => {
        this.addAgencyForm.get("companyId").patchValue("");
      },
      reject: () => {},
    });
  }

  showRemoveCompany() {
    const company = this.addAgencyForm?.value?.companyId?.value;

    if (company && company !== "") {
      return true;
    } else {
      return false;
    }
  }

  getCompanies() {
    try {
      this.progressBarService.setProgressBarVisibility(true);
      this.subscriptions.push(
        this.companyService.getAllCompanies({ pagination: { pageNumber: 0, pageSize: 10000 } }).subscribe((res) => {
          if (res?.success) {
            this.companyPayload = res.content.data;
            const activeCompanies = res.content.data.filter((company) => company.status == UserStatus.active);
            this.companies = activeCompanies.map((item) => ({ label: item.name, value: item.id }));
          } else if (res) {
            this.messageHandlerService.generateToastMessage("error", "Communication error:  ", res?.errorMessage);
          }
          this.progressBarService.setProgressBarVisibility(false);
        }),
      );
    } catch (error) {
      this.progressBarService.setProgressBarVisibility(false);
      this.messageHandlerService.generateToastMessage("error", "Communication error:  ", error);
    }
  }

  filterCompanies(event) {
    let filtered: any[] = [];
    let query = event.query;
    const newUserCompanies = this.companies.filter((company) => company.label !== "All" && company.value !== "");

    for (let i = 0; i < newUserCompanies.length; i++) {
      let checkIfAlreadySelected = false;
      let company = newUserCompanies[i];
      if (company?.label?.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        const formData = this.addAgencyForm.value;

        if (company?.value && formData?.companyId?.value == company?.value) {
          checkIfAlreadySelected = true;
        }

        if (!checkIfAlreadySelected) {
          filtered.push(company);
        }
      }
    }

    this.filteredCompanies = filtered;
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    this.stopCodeCountdown();
  }

  getCurrentAgencyRole() {
    this.subscriptions.push(
      this.userDataManager.activeAgencyRole$.subscribe((currentRole) => {
        this.currentAgencyRole = currentRole;
        if (
          this.currentAgencyRole.role == RoleID.Admin ||
          this.currentAgencyRole.role == RoleID.iohAdmin ||
          this.currentAgencyRole.role == RoleID.companyAdmin ||
          this.currentAgencyRole.role == RoleID.AgencyAdmin
        ) {
          this.getAgencies();
        } else {
          this.agencies = [];
        }
      }),
    );
  }

  getPortalFeatureObject(): any {
    let features = {};
    portalFeatureValues.forEach((portalFeature) => {
      features[portalFeature.name] = false;
    });
    return features;
  }

  createAgencyForm() {
    this.disableDiagnosisGroups = !this.disableDiagnosisGroups;
    this.selectedDiagnosisGroups = [];
    this.addAgencyForm = this.formBuilder.group({
      picture: [null, Validators.required],
      name: ["", Validators.required],
      shortName: ["", Validators.required],
      agencyReferenceName: ["", [Validators.required, Validators.pattern(BRANCH_CODES_PATTERN), uniqueBranchCodesValidator]],
      phoneNumber: this.formBuilder.group({
        number: [""],
        countryCode: [countries[0].dial_code],
      }),
      portalFeatures: this.formBuilder.group(this.getPortalFeatureObject()),
      fax: this.formBuilder.group({
        number: [""],
        countryCode: [countries[0].dial_code],
      }),
      email: ["", [Validators.required, Validators.email]],
      status: ["Active"],
      loginWithPCIDenabled: [CompanyUserRegistrationTypeEnum.NotSet],
      agencyLevel: [""],
      address: this.formBuilder.group({
        state: ["", Validators.required],
        city: ["", Validators.required],
        line1: ["", Validators.required],
        line2: [""],
        postalCode: ["", Validators.required],
      }),
      totalAttempts: [""],
      linkExpireDuration: [DEFAULT_AGENCY_EDOC_LINK_EXPIRATION_TIME],
      appSettings: this.formBuilder.group(appSettings),
      defaultDiagnosisGroup: [""],
      nonMDMCustomer: [NonMDMCustomerEnum.NotSet],
      diagnosisGroups: [""],
      disableDiagnosisGroups: [this.disableDiagnosisGroups],
      SMSTemplate: [""],
      emailTemplate: [""],
      emailTemplates: this.formBuilder.group({
        piTemplate: this.formBuilder.group({ email: this.formBuilder.group({ body: [""] }) }),
        phTemplate: this.formBuilder.group({ email: this.formBuilder.group({ body: [""] }) }),
        otherTemplate: this.formBuilder.group({ email: this.formBuilder.group({ body: [""] }) }),
        esignTemplate: this.formBuilder.group({ email: this.formBuilder.group({ body: [""] }) }),
        hosAddendumTemplate: this.formBuilder.group({ email: this.formBuilder.group({ body: [""] }) }),
        hosAddendumOverdueTemplate: this.formBuilder.group({ email: this.formBuilder.group({ body: [""] }) }),
      }),
      smsTemplates: this.formBuilder.group({
        piTemplate: this.formBuilder.group({ sms: [""] }),
        phTemplate: this.formBuilder.group({ sms: [""] }),
        otherTemplate: this.formBuilder.group({ sms: [""] }),
        esignTemplate: this.formBuilder.group({ sms: [""] }),
        hosAddendumTemplate: this.formBuilder.group({ sms: [""] }),
        hosAddendumOverdueTemplate: this.formBuilder.group({ sms: [""] }),
      }),
      hosAddendumConfig: this.formBuilder.group({
        initialClockValue: [5],
        subsequentClockValue: [3],
        clockUnit: ["days"],
        notificationEmails: [""],
        stampText: ["UNABLE TO OBTAIN SIGNATURE"],
        notifySenderOnDeliveryFailure: [false],
      }),
      hideCopySigningLink: [false],
      companyId: [""],
      isIOHHelp: true,
    });
    if (this.currentUser.is_super_admin || this.currentUser.is_IOH_admin) {
      this.companyRequired();
    }
    this.addAgencyForm.valueChanges.subscribe(() => {
      const getInvalidControls = (formGroup: any, parentName = '') => {
        let invalid = [];
        Object.keys(formGroup.controls).forEach(key => {
          const control = formGroup.controls[key];
          const controlName = parentName ? `${parentName}.${key}` : key;
          if (control.invalid) {
            if (control instanceof FormGroup) {
              invalid = invalid.concat(getInvalidControls(control, controlName));
            } else {
              invalid.push({ name: controlName, errors: control.errors, value: control.value });
            }
          } else if (control instanceof FormGroup) {
            invalid = invalid.concat(getInvalidControls(control, controlName));
          }
        });
        return invalid;
      };
      console.log('--- INVALID CONTROLS ---', getInvalidControls(this.addAgencyForm));
    });
    this.patchDefaultTemplatesForCreate();
  }

  /**
   * Sets default email/SMS template text for Add Agency only.
   * Uses nested control paths so values bind reliably (edit flow never calls this).
   */
  private patchDefaultTemplatesForCreate(): void {
    if (!this.addAgencyForm) {
      return;
    }
    const keys = [
      "phTemplate",
      "piTemplate",
      "otherTemplate",
      "esignTemplate",
      "hosAddendumTemplate",
      "hosAddendumOverdueTemplate",
    ] as const;
    for (const key of keys) {
      this.addAgencyForm
        .get(`emailTemplates.${key}.email.body`)
        ?.setValue(AGENCY_TEMPLATE_DEFAULT_EMAIL_BODIES[key], { emitEvent: false });
      this.addAgencyForm.get(`smsTemplates.${key}.sms`)?.setValue(AGENCY_TEMPLATE_DEFAULT_SMS[key], { emitEvent: false });
    }
  }

  async onSelect(event) {
    const file = event.files[0];

    const formData = new FormData();
    formData.append("file", file);

    if (event.currentFiles && event.currentFiles.length > 0) {
      this.progressBarService.setProgressBarVisibility(true);
      await this.agencyService.uploadFile(formData).subscribe((res) => {
        if (res?.message?.Location) {
          this.currentImage = res;
          this.addAgencyForm.get("picture").setValue(res.message.Location);
          this.fileUpload.clear();
        }
        this.progressBarService.setProgressBarVisibility(false);
      });
    }
  }

  async deleteFile() {
    await this.agencyService
      .deleteFile({
        bucketName: "grandcare",
        objectKey: this.addAgencyForm.value.picture,
      })
      .subscribe((res) => {
        if (res) {
          this.currentImage = null;
          this.fileUpload.clear();
          this.addAgencyForm.patchValue({ picture: null });
        }
      });
  }

  handleEDocsFileUpload(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    // only pdf files are allowed
    if (!ALLOWED_SOC_PACKET_FILE_FORMATS.includes(file.type)) {
      this.messageHandlerService.generateToastMessage("error", 'File type error',SOC_PACKET_FILE_FORMAT_ERROR);
      return;
    }

    this.eDocsFileName = file.name;
    this.showEDocsDragAndDrop = false;
    this.showEDocsFileInfo = true;
    this.eDocsUploadProgressBar = true;
    this.eDocsUploadValue = 0;
    this.isEDocsUploading = true;
    this.eDocsFileDeleted = false;

    const formData = new FormData();
    formData.append('file', file);

    const documentType = 'file';
    formData.append('documentTypes[]', documentType);

    this.agencyService.uploadSocFileWithProgress(formData).subscribe({
      next: (event) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.eDocsUploadValue = event.total
            ? Math.round(100 * event.loaded / event.total)
            : 0;
        } else if (event.type === HttpEventType.Response) {
          this.eDocsUploadValue = 100;
          const res = event.body;

          if (res?.message?.Location) {
            this.eDocsFile = {
              fileOriginalName: this.eDocsFileName,
              fileName: res.message.Key,
              fileLocation: res.message.Location,
            };
            this.eDocsFileUploadedAt = this.datePipe.transform(new Date(), "MM-dd-yyyy hh:mm a") || "";
          } else {
            this.eDocsFile = null;
            this.showEDocsDragAndDrop = true;
            this.showEDocsFileInfo = false;
            this.eDocsFileName = '';
            this.eDocsFileUploadedAt = '';
            this.messageHandlerService.generateToastMessage('error', '', 'Unable to upload file');
          }

          this.isEDocsUploading = false;
          setTimeout(() => {
            this.eDocsUploadProgressBar = false;
            this.eDocsUploadValue = 0;
          }, 1000);
        }
      },
      error: () => {
        this.resetEDocsUploadState();
        this.messageHandlerService.generateToastMessage('error', '', 'Unable to upload file');
      }
    });
  }

  deleteEdocFileConfirmation() {
    this.confirmationService.confirm({
      message: "Are you sure you want to delete the document?",
      header: "Delete eSOC",
      acceptButtonStyleClass: "btn-delete",
      icon: "pi pi-trash",
      accept: () => {
        this.deleteEDocsFile();
      },
      reject: (type) => {},
    });
  }

  deleteEDocsFile() {
    if (this.isEDocsUploading) return;
    this.eDocsFile = null;
    this.eDocsFileName = '';
    this.eDocsFileUploadedAt = '';
    this.showEDocsDragAndDrop = true;
    this.showEDocsFileInfo = false;
    this.eDocsFileDeleted = true;
  }

  updateEsockFile() {
    this.confirmationService.confirm({
      message: "Are you sure you want to upload a new document, as it will override the previous one?",
      header: "Update eSOC",
      icon: "pi pi-upload",
      accept: () => {
        this.resetEDocsUploadState();
      },
      reject: (type) => {},
    });
  }


  private clearEDocsUploadInterval() {
    if (this.eDocsUploadIntervalId) {
      clearInterval(this.eDocsUploadIntervalId);
      this.eDocsUploadIntervalId = null;
    }
  }

  private resetEDocsUploadState() {
    this.clearEDocsUploadInterval();
    this.eDocsFile = null;
    this.eDocsFileName = '';
    this.eDocsFileUploadedAt = '';
    this.showEDocsDragAndDrop = true;
    this.showEDocsFileInfo = false;
    this.eDocsUploadProgressBar = false;
    this.eDocsUploadValue = 0;
    this.isEDocsUploading = false;
    this.eDocsFileDeleted = false;
    this.isSigningDocUploading = false;
    this.signingDocUploadProgressBar = false;
    this.signingDocUploadValue = 0;
  }

  handleSigningDocUpload(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    if (!ALLOWED_SOC_PACKET_FILE_FORMATS.includes(file.type)) {
      this.messageHandlerService.generateToastMessage("error", 'File type error', SOC_PACKET_FILE_FORMAT_ERROR);
      return;
    }

    // Reject a document whose name is already in the list, to avoid duplicate signing
    // templates and the confusion of two identically-named files (IOHB-1632).
    const uploadName = (file.name || '').trim().toLowerCase();
    const isDuplicateName = this.patientSigningDocuments.some(
      (doc: any) => (doc.fileOriginalName || '').trim().toLowerCase() === uploadName
    );
    if (isDuplicateName) {
      this.messageHandlerService.generateToastMessage('error', 'Duplicate file', `A document named "${file.name}" has already been added.`);
      return;
    }

    this.isSigningDocUploading = true;
    this.signingDocUploadProgressBar = true;
    this.signingDocUploadValue = 0;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('documentTypes[]', 'file');

    this.agencyService.uploadSocFileWithProgress(formData).subscribe({
      next: (event) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.signingDocUploadValue = event.total
            ? Math.round(100 * event.loaded / event.total)
            : 0;
        } else if (event.type === HttpEventType.Response) {
          this.signingDocUploadValue = 100;
          const res = event.body;

          if (res?.message?.Location) {
            const newDoc = {
              fileOriginalName: file.name,
              fileName: res.message.Key,
              fileLocation: res.message.Location,
              createdAt: new Date().toISOString()
            };
            this.patientSigningDocuments = [newDoc, ...this.patientSigningDocuments];
            this.messageHandlerService.generateToastMessage('success', '', 'File uploaded successfully');
          } else {
            this.messageHandlerService.generateToastMessage('error', '', 'Unable to upload file');
          }

          this.isSigningDocUploading = false;
          setTimeout(() => {
            this.signingDocUploadProgressBar = false;
            this.signingDocUploadValue = 0;
          }, 1000);
        }
      },
      error: () => {
        this.isSigningDocUploading = false;
        this.signingDocUploadProgressBar = false;
        this.signingDocUploadValue = 0;
        this.messageHandlerService.generateToastMessage('error', '', 'Unable to upload file');
      }
    });
  }

  deleteSigningDoc(index: number) {
    this.confirmationService.confirm({
      message: "Are you sure you want to delete this signing document template?",
      header: "Delete Signing Document",
      acceptButtonStyleClass: "btn-delete",
      icon: "pi pi-trash",
      accept: () => {
        this.patientSigningDocuments.splice(index, 1);
        this.patientSigningDocuments = [...this.patientSigningDocuments];
      }
    });
  }

  viewSigningDoc(doc: any) {
    const fileName = doc?.fileName;
    if (!fileName) return;
    this.esocService.getEPHfileObjectUrl({ fileName }).subscribe({
      next: (res) => {
        if (res?.success && res.url) {
          window.open(res.url, "_blank");
        } else {
          this.messageHandlerService.generateToastMessage("error", "", "Error viewing file: " + (res?.message || "Invalid URL"));
        }
      },
      error: (err) => {
        this.messageHandlerService.generateToastMessage("error", "", "Error viewing file: " + (err?.message || err));
      }
    });
  }

  viewEDocsFile() {
    const fileName = this.eDocsFile?.fileName;
    if (!fileName) return;
    this.esocService.getEPHfileObjectUrl({ fileName }).subscribe({
      next: (res) => {
        if (res?.success && res.url) {
          window.open(res.url, "_blank");
        } else {
          this.messageHandlerService.generateToastMessage("error", "", "Error viewing file: " + (res?.message || "Invalid URL"));
        }
      },
      error: (err) => {
        this.messageHandlerService.generateToastMessage("error", "", "Error viewing file: " + (err?.message || err));
      }
    });
  }

  getUserProfile() {
    this.subscriptions.push(
      this.userDataManager.user$.subscribe((res) => {
        if (res) {
          this.currentUser = res;
        }
      }),
    );
  }

  getRoleBasedAgencyListing(role: string) {
    this.agencyService.getRoleBasedAgencyListing(role, this.currentUser.agency_roles).subscribe((res) => {
      if (res.content.data) {
        this.agencies = res.content.data;
      }
    });
  }

  getCompanyID() {
    if (this.currentUser.is_company_admin && this.currentUser.currentUserRole === RoleID.companyAdmin) {
      return this.currentUser.companyId;
    }
    return null;
  }

  // find agencies with pagination and search
  getAgencies() {
    try {
      this.progressBarService.setProgressBarVisibility(true);
      this.loading = true;
      let request = {
        companyId: this.getCompanyID(),
        search: this.searchAgency ? this.searchAgency : "",
        status: this.agencyStatusFilter,
        agencyLevel: this.agencyLevelFilter,
        agencyID: this.getAgencyID(),
        pagination: {
          // pageNumber: this.agencyStatusFilter === "" && this.agencyLevelFilter === "" ? this.pageNo : 0,
          // pageSize: this.noOfAgenciesPerRow,
          pageNumber: this.pageNo,
          pageSize: this.noOfAgenciesPerRow,
        },
        selectedAgency: this.selectedAgencyIdFromParams,
      };
      this.subscriptions.push(
        this.agencyService.getAgenciesWithSearch(request).subscribe((res) => {
          if (res?.success) {
            this.agencies = res.content.data;
            this.totalAgencies = res.content.totalAgenciesCount;
            this.selectedAgenciesToExport = [];
           // this.rangeDates = null;
          //  this.dateRangeToExportAgencyData = {};
            if (!this.isChangingPage) {
              this.changePage();
            }

            this.getAgencyValuesFromStore();

            if (this.selectedAgencyIdFromParams && this.agencies && this.agencies.length) {
              this.openEditUserForm(this.agencies[0]);
            }
          } else if (res) {
            this.messageHandlerService.generateToastMessage("error", "Communication error:  ", res?.errorMessage);
          }
          this.progressBarService.setProgressBarVisibility(false);
          this.loading = false;
        }),
      );
    } catch (error) {
      this.progressBarService.setProgressBarVisibility(false);
      this.loading = false;
      this.messageHandlerService.generateToastMessage("error", "Communication error:  ", error);
    }
  }

  getAgencyID() {
    if (this.currentAgencyRole.role == RoleID.AgencyAdmin) {
      return this.currentAgencyRole.agency;
    }
    return null;
  }

  searchAgencies() {
    if (this.searchAgency === undefined || this.searchAgency === null || this.searchAgency === "") {
      this.getAgencies();
    } else if (this.searchAgency && this.searchAgency.length >= this.defaultSearchMinCharacter) {
      this.pageNo = 0;
      this.getAgencies();
    }
  }

  // Check if the agency search field is empty
  isSearchEmpty() {
    if (this.searchAgency === undefined || this.searchAgency === null || this.searchAgency === "") {
      this.pageNo = 0;
      this.getAgencies();
    }
  }

  private applyDynamicEmailSubjects(agency: any): void {
    const agencyName = agency?.shortName || agency?.name || '';
    const subjectByTemplate = {
      phTemplate: `Your Patient Handbook from ${agencyName}`,
      piTemplate: `Updated Patient Information from ${agencyName}`,
      otherTemplate: `Important Documents from ${agencyName}`,
      esignTemplate: `Important Documents from ${agencyName}`,
      hosAddendumTemplate: `${agencyName} - Hospice Non-Covered Items, Services, and Drugs Notification (HOS Addendum)`,
      hosAddendumOverdueTemplate: `[URGENT] ${agencyName} - Action Required: HOS Addendum Signature Overdue`,
    };

    if (agency.emailTemplates) {
      for (const key of Object.keys(subjectByTemplate)) {
        if (agency.emailTemplates[key]?.email) {
          agency.emailTemplates[key].email.subject = subjectByTemplate[key];
        }
      }
    }
  }

  /**
   * API expects `emailTemplates` to only contain `{ email: { subject, body } }` and
   * `smsTemplates` to only contain `{ sms }` — strip any cross-nested fields (e.g. legacy `sms` on emailTemplates).
   */
  private sanitizeTemplatePayloadForApi(agency: any): void {
    const keys = [
      "phTemplate",
      "piTemplate",
      "otherTemplate",
      "esignTemplate",
      "hosAddendumTemplate",
      "hosAddendumOverdueTemplate",
    ] as const;
    for (const key of keys) {
      const et = agency?.emailTemplates?.[key];
      if (et && typeof et === "object" && "sms" in et) {
        delete et.sms;
      }
      const st = agency?.smsTemplates?.[key];
      if (st && typeof st === "object" && "email" in st) {
        delete st.email;
      }
    }
  }

  createAgency() {
    let newAgency = this.addAgencyForm.value;
    newAgency.createdBy = this.currentUser.aws_cognito_id;
    newAgency.createdAt = new Date();
    newAgency.linkExpireDuration = newAgency.linkExpireDuration ? newAgency.linkExpireDuration : DEFAULT_AGENCY_EDOC_LINK_EXPIRATION_TIME;
    newAgency.totalAttempts = newAgency.totalAttempts ? newAgency.totalAttempts : 0;

    if (this.eDocsFile) {
      newAgency.eDocsFile = this.eDocsFile;
    }
    newAgency.patientSigningDocuments = this.patientSigningDocuments;

    if (this.currentUser.is_company_admin && this.currentUser.currentUserRole === RoleID.companyAdmin) {
      newAgency.companyId = this.currentUser.companyId;
    }

    if (this.currentUser.is_super_admin || this.currentUser.is_IOH_admin) {
      // The form's value is reused by the next Add while the form stays open after a refused save, and by
      // then this has already turned the company into its id - a string, which `in` cannot search.
      if (
        newAgency.companyId &&
        typeof newAgency.companyId !== "string" &&
        "label" in newAgency.companyId &&
        "value" in newAgency.companyId
      ) {
        newAgency.companyId = newAgency.companyId.value;
      }
    }

    if (this.isIoDocEnabledOnAgency(newAgency)) {
      this.applyDynamicEmailSubjects(newAgency);
    } else {
      this.clearIoDocTemplatePayload(newAgency);
    }
    this.sanitizeTemplatePayloadForApi(newAgency);

    if (newAgency.hosAddendumConfig) {
      const rawEmails = newAgency.hosAddendumConfig.notificationEmails;
      if (typeof rawEmails === "string") {
        newAgency.hosAddendumConfig.notificationEmails = rawEmails
          .split(",")
          .map((e: string) => e.trim())
          .filter(Boolean);
      }
    }

    this.subscriptions.push(
      this.agencyService.createAgency(newAgency).subscribe((res) => {
        if (res.success) {
          this.getAgencies();
          this.display = false;
          this.messageHandlerService.generateToastMessage("success", "", "Agency Created Successfully");
          this.sideNavService.setEDocPurchase();
        } else {
          this.messageHandlerService.generateToastMessage("error", "", this.refusalReason(res) || "Agency Not Created");
        }
      }),
    );
  }

  /**
   * Why the server refused a save, when it is something the user can fix: an agency saved with no
   * branch code comes back as 400, and a branch code another agency of the company already uses as
   * 409, each with the reason in message. Empty for any other failure, which keeps its usual text.
   */
  private refusalReason(res: any): string {
    return (res?.returnCode === 400 || res?.returnCode === 409) && typeof res?.message === "string" ? res.message : "";
  }

  onSlideBarClose() {
    this.display = false;
    this.selectedAppLinkId = null;
    this.showEditForm = false;
    this.addAgencyForm.reset();
    this.portalFeatures[0].value = false;
    this.resetEDocsUploadState();
    this.patientSigningDocuments = [];
    this.deliveryDestinations = [];
    this.addDestinationDialogVisible = false;
    this.verifyDestinationDialogVisible = false;
    this.selectedDestination = null;
    this.destinationValue = '';
    this.verificationCodeInput = '';
    if (this.nonMdmCustomerChangeSub) {
      this.nonMdmCustomerChangeSub.unsubscribe();
      this.nonMdmCustomerChangeSub = undefined;
    }
  }

  private clearAppLinksState(): void {
    this.selectedAppLinkId = null;
    this.appLinks = [];
    this.appLinkOptions = [];
    this.isFetchingAppLinks = false;
  }

  private setupNonMdmCustomerSubscription(): void {
    if (this.nonMdmCustomerChangeSub) {
      this.nonMdmCustomerChangeSub.unsubscribe();
      this.nonMdmCustomerChangeSub = undefined;
    }

    const control = this.addAgencyForm?.get("nonMDMCustomer");
    if (!control) return;

    const apply = (value) => {
      if (OnlySuperAdminAllowedRoles.includes(this.currentUser?.currentUserRole) && value === NonMDMCustomerEnum.Enabled) {
        this.fetchAppLinks();
      } else {
        this.clearAppLinksState();
      }
    };

    apply(control.value);
    this.nonMdmCustomerChangeSub = control.valueChanges.subscribe((value) => apply(value));
  }

  checkIfEmailExists() {
    this.subscriptions.push(
      this.agencyService.findAgencyByEmail({ email: this.addAgencyForm.value.email }).subscribe((res) => {
        if (res.success && res.content.data.length) {
          this.messageHandlerService.generateToastMessage("error", "", EMAIL_ALREADY_REGISTERED_AGENCY);
        } else if (res.success && !res.content.data.length) {
          this.createAgency();
        } else {
          this.messageHandlerService.generateToastMessage("error", "", res.errorMessage);
        }
      }),
    );
  }

  openEditUserForm(agency) {
    this.selectedIndex = agency;
    this.selectedDiagnosisGroups = this.toDiagnosisGroupValues(this.selectedIndex?.diagnosisGroups);
    this.disableDiagnosisGroups = this.selectedIndex?.disableDiagnosisGroups;
    //console.log('disableDiagnosisGroups === ', this.disableDiagnosisGroups);
    this.showEditForm = true;
    if (
      this.currentUser.is_super_admin ||
      this.currentUser.is_IOH_admin ||
      this.currentUser.is_company_admin ||
      (this.currentUser.defaultRole === RoleID.AgencyAdmin && this.agenciesAllowed?.includes(agency?.id))
    ) {
      this.display = true;
    }
    let agencyFeatures = agency?.portalFeatures;
    this.portalFeatures?.forEach((feature) => {
      feature.value = agencyFeatures ? agencyFeatures[feature.name] : false;
    });
    this.prepareEditAgencyForm();
    this.createEditAgencyForm();
    this.isSuperAdminOnlyRole = OnlySuperAdminAllowedRoles.includes(this.currentUser?.currentUserRole);
    this.setupNonMdmCustomerSubscription();
  }

  onDeleteClick() {
    this.onSlideBarClose();
    this.confirmationService.confirm({
      message: "Please confirm if you wanted to delete Agency",
      header: "Delete Agency?",
      icon: "pi pi-trash",
      acceptLabel: "Delete",
      rejectLabel: "Cancel",
      acceptButtonStyleClass: "btn-delete",
      accept: () => {
        this.deleteAgency();
      },
      reject: () => {},
    });
  }

  deleteAgency78() {
    if (this.currentUser.is_super_admin || this.currentUser.is_company_admin) {
      this.subscriptions.push(
        this.agencyService.deleteAgency(this.selectedIndex.id).subscribe(
          (res: any) => {
            this.getAgencies();
            this.messageHandlerService.generateToastMessage("success", "", "Agency Deleted Successfully");
          },
          (error) => {
            this.messageHandlerService.generateToastMessage("error", "", "Error In Deleting Agency");
          },
        ),
      );
    } else {
      this.messageHandlerService.generateToastMessage("error", "", "Only Admin can delete agency");
    }
  }

  deleteAgency() {
    this.subscriptions.push(
      this.agencyService.deleteAgency(this.selectedIndex.id).subscribe(
        (res: any) => {
          if (res?.success) {
            this.getAgencies();
            this.messageHandlerService.generateToastMessage("success", "", "Agency Deleted Successfully");
          } else {
            this.messageHandlerService.generateToastMessage("error", "", "Error In Deleting Agency: " + res?.message);
          }
        },
        (error) => {
          this.messageHandlerService.generateToastMessage("error", "", "Error In Deleting Agency");
        },
      ),
    );
  }

  prepareEditAgencyForm() {
    this.addAgencyForm = this.formBuilder.group({
      picture: [null, Validators.required],
      name: ["", Validators.required],
      agencyReferenceName: ["", [Validators.required, Validators.pattern(BRANCH_CODES_PATTERN), uniqueBranchCodesValidator]],
      shortName: ["", Validators.required],
      phoneNumber: this.formBuilder.group({
        number: [""],
        countryCode: [""],
      }),
      portalFeatures: this.formBuilder.group(this.getPortalFeatureObject()),
      fax: this.formBuilder.group({
        number: [""],
        countryCode: [""],
      }),
      email: ["", [Validators.required, Validators.email]],
      status: [""],
      loginWithPCIDenabled: [""],
      agencyLevel: [""],
      address: this.formBuilder.group({
        state: ["", Validators.required],
        city: ["", Validators.required],
        line1: ["", Validators.required],
        line2: [""],
        postalCode: ["", Validators.required],
      }),
      totalAttempts: [""],
      linkExpireDuration: [""],
      appSettings: this.formBuilder.group(appSettings),
      defaultDiagnosisGroup: [""],
      disableDiagnosisGroups: [this.disableDiagnosisGroups],
      diagnosisGroups: [""],
      SMSTemplate: [""],
      emailTemplate: [""],
      emailTemplates: this.formBuilder.group({
        piTemplate: this.formBuilder.group({ email: this.formBuilder.group({ body: [""] }) }),
        phTemplate: this.formBuilder.group({ email: this.formBuilder.group({ body: [""] }) }),
        otherTemplate: this.formBuilder.group({ email: this.formBuilder.group({ body: [""] }) }),
        esignTemplate: this.formBuilder.group({ email: this.formBuilder.group({ body: [""] }) }),
        hosAddendumTemplate: this.formBuilder.group({ email: this.formBuilder.group({ body: [""] }) }),
        hosAddendumOverdueTemplate: this.formBuilder.group({ email: this.formBuilder.group({ body: [""] }) }),
      }),
      smsTemplates: this.formBuilder.group({
        piTemplate: this.formBuilder.group({ sms: [""] }),
        phTemplate: this.formBuilder.group({ sms: [""] }),
        otherTemplate: this.formBuilder.group({ sms: [""] }),
        esignTemplate: this.formBuilder.group({ sms: [""] }),
        hosAddendumTemplate: this.formBuilder.group({ sms: [""] }),
        hosAddendumOverdueTemplate: this.formBuilder.group({ sms: [""] }),
      }),
      hosAddendumConfig: this.formBuilder.group({
        initialClockValue: [5],
        subsequentClockValue: [3],
        clockUnit: ["days"],
        notificationEmails: [""],
        stampText: ["UNABLE TO OBTAIN SIGNATURE"],
        notifySenderOnDeliveryFailure: [false],
      }),
      hideCopySigningLink: [false],
      companyId: [""],
      isIOHHelp: true,
      nonMDMCustomer: [NonMDMCustomerEnum.NotSet],
    });
    if (this.currentUser.is_super_admin || this.currentUser.is_IOH_admin) {
      this.companyRequired();
    }
  }

  createEditAgencyForm() {
    this.addAgencyForm.patchValue({
      picture: this.selectedIndex.picture,
      name: this.selectedIndex.name,
      shortName: this.selectedIndex.shortName,
      agencyReferenceName: this.selectedIndex.agencyReferenceName,
      phoneNumber: {
        number: this.selectedIndex.phoneNumber?.number,
        countryCode: this.selectedIndex.phoneNumber?.countryCode,
      },
      fax: {
        number: this.selectedIndex.fax?.number,
        countryCode: this.selectedIndex.fax?.countryCode,
      },
      email: this.selectedIndex.email,
      status: this.selectedIndex.status,
      loginWithPCIDenabled: this.selectedIndex.loginWithPCIDenabled,
      agencyLevel: this.selectedIndex.agencyLevel,
      address: {
        state: this.selectedIndex.address.state,
        city: this.selectedIndex.address.city,
        line1: this.selectedIndex.address.line1,
        line2: this.selectedIndex.address.line2,
        postalCode: this.selectedIndex.address.postalCode,
      },
      totalAttempts: this.selectedIndex.totalAttempts ? this.selectedIndex.totalAttempts : 0,
      linkExpireDuration: this.selectedIndex.linkExpireDuration ? this.selectedIndex.linkExpireDuration : DEFAULT_AGENCY_EDOC_LINK_EXPIRATION_TIME,

      portalFeatures: {
        ...this.getPortalFeatureObject(),
        ...(this.selectedIndex?.portalFeatures || {}),
      },

      appSettings: {
        appSettings,
        ...this.selectedIndex.appSettings,
      },
      defaultDiagnosisGroup: this.selectedIndex?.defaultDiagnosisGroup,
      diagnosisGroups: this.toDiagnosisGroupValues(this.selectedIndex?.diagnosisGroups),
      disableDiagnosisGroups: this.selectedIndex?.disableDiagnosisGroups,
      SMSTemplate: this.selectedIndex?.SMSTemplate,
      emailTemplate: this.selectedIndex?.emailTemplate,
      emailTemplates: {
        piTemplate: { email: { body: this.getApiTemplateEmailBody("piTemplate") } },
        phTemplate: { email: { body: this.getApiTemplateEmailBody("phTemplate") } },
        otherTemplate: { email: { body: this.getApiTemplateEmailBody("otherTemplate") } },
        esignTemplate: { email: { body: this.getApiTemplateEmailBody("esignTemplate") } },
        hosAddendumTemplate: { email: { body: this.getApiTemplateEmailBody("hosAddendumTemplate") } },
        hosAddendumOverdueTemplate: { email: { body: this.getApiTemplateEmailBody("hosAddendumOverdueTemplate") } },
      },
      smsTemplates: {
        piTemplate: { sms: this.getApiTemplateSms("piTemplate") },
        phTemplate: { sms: this.getApiTemplateSms("phTemplate") },
        otherTemplate: { sms: this.getApiTemplateSms("otherTemplate") },
        esignTemplate: { sms: this.getApiTemplateSms("esignTemplate") },
        hosAddendumTemplate: { sms: this.getApiTemplateSms("hosAddendumTemplate") },
        hosAddendumOverdueTemplate: { sms: this.getApiTemplateSms("hosAddendumOverdueTemplate") },
      },
      hosAddendumConfig: {
        initialClockValue: this.selectedIndex?.hosAddendumConfig?.initialClockValue ?? 5,
        subsequentClockValue: this.selectedIndex?.hosAddendumConfig?.subsequentClockValue ?? 3,
        clockUnit: this.selectedIndex?.hosAddendumConfig?.clockUnit ?? "days",
        notificationEmails: Array.isArray(this.selectedIndex?.hosAddendumConfig?.notificationEmails)
          ? this.selectedIndex.hosAddendumConfig.notificationEmails.join(", ")
          : (this.selectedIndex?.hosAddendumConfig?.notificationEmails || ""),
        stampText: this.selectedIndex?.hosAddendumConfig?.stampText || "UNABLE TO OBTAIN SIGNATURE",
        notifySenderOnDeliveryFailure: this.selectedIndex?.hosAddendumConfig?.notifySenderOnDeliveryFailure === true,
      },
      hideCopySigningLink: this.selectedIndex?.hideCopySigningLink === true,
      companyId: this.companies.filter((e) => e.value === this.selectedIndex.companyId?._id)[0],
      isIOHHelp: this.selectedIndex?.isIOHHelp ? this.selectedIndex?.isIOHHelp : false,
      nonMDMCustomer: this.selectedIndex?.nonMDMCustomer !== undefined && this.selectedIndex?.nonMDMCustomer !== null
        ? (
          this.selectedIndex?.nonMDMCustomer === true ||
          this.selectedIndex?.nonMDMCustomer === 'true' ||
          this.selectedIndex?.nonMDMCustomer === NonMDMCustomerEnum.Enabled
            ? NonMDMCustomerEnum.Enabled
            : (
              this.selectedIndex?.nonMDMCustomer === false ||
              this.selectedIndex?.nonMDMCustomer === 'false' ||
              this.selectedIndex?.nonMDMCustomer === NonMDMCustomerEnum.Disabled
                ? NonMDMCustomerEnum.Disabled
                : NonMDMCustomerEnum.NotSet
            )
        )
        : NonMDMCustomerEnum.NotSet,
      // tagLine: this.selectedIndex?.tagLine,
      // emailTemplate: this.selectedIndex?.emailTemplate
    });

    const getDocTimestamp = (doc: any) => {
      if (doc.createdAt) return new Date(doc.createdAt).getTime();
      const match = doc.fileName?.match(/\b(\d{13})\b/);
      if (match) return parseInt(match[1], 10);
      return 0;
    };
    this.patientSigningDocuments = (this.selectedIndex?.patientSigningDocuments || [])
      .slice()
      .sort((a: any, b: any) => getDocTimestamp(b) - getDocTimestamp(a));

    if (this.selectedIndex?.eDocsFile?.fileLocation) {
      this.eDocsFile = this.selectedIndex.eDocsFile;
      this.eDocsFileName = this.selectedIndex.eDocsFile.fileOriginalName || this.selectedIndex.eDocsFile.fileName;
      this.eDocsFileUploadedAt = this.getEDocsUploadedDateDisplay(this.selectedIndex.eDocsFile);
      this.showEDocsDragAndDrop = false;
      this.showEDocsFileInfo = true;
      this.eDocsFileDeleted = false;
    } else {
      this.resetEDocsUploadState();
    }
    this.openDeliverySettings(this.openAgencyId());
  }

  getCompanySelectedIcon(index) {
    const selectedIndex = this.companyPayload.find((e) => e.id === index?.value);

    return selectedIndex?.logo ?? "";
  }

  onUpdateClick() {
    let updatedAgency = {
      ...this.selectedIndex,
      ...this.addAgencyForm.value,
      portalFeatures: this.getPortalFeaturesToSave(),
    };

    if (this.eDocsFile) {
      updatedAgency.eDocsFile = this.eDocsFile;
    } else if (this.eDocsFileDeleted) {
      updatedAgency.eDocsFile = null;
    } else if (this.selectedIndex?.eDocsFile) {
      updatedAgency.eDocsFile = this.selectedIndex.eDocsFile;
    }
    updatedAgency.patientSigningDocuments = this.patientSigningDocuments;

    if (this.isIoDocEnabledOnAgency(updatedAgency)) {
      this.applyDynamicEmailSubjects(updatedAgency);
    } else {
      this.clearIoDocTemplatePayload(updatedAgency);
    }

    if (updatedAgency.hosAddendumConfig) {
      const rawEmails = updatedAgency.hosAddendumConfig.notificationEmails;
      if (typeof rawEmails === "string") {
        updatedAgency.hosAddendumConfig.notificationEmails = rawEmails
          .split(",")
          .map((e: string) => e.trim())
          .filter(Boolean);
      }
    }

    this.onSlideBarClose();
    this.confirmationService.confirm({
      message: "Please confirm if you wanted to save all the changes that you've made to this agency",
      header: "Confirm Changes?",
      icon: "pi pi-cog",
      acceptLabel: "Update",
      rejectLabel: "Cancel",
      accept: () => {
        this.updateAgency(updatedAgency);
      },
      reject: () => {},
    });
  }

  updateAgency(agencyToUpdate: Agency) {
    this.sanitizeTemplatePayloadForApi(agencyToUpdate);

    agencyToUpdate.linkExpireDuration = agencyToUpdate.linkExpireDuration
      ? agencyToUpdate.linkExpireDuration
      : DEFAULT_AGENCY_EDOC_LINK_EXPIRATION_TIME;
    agencyToUpdate.totalAttempts = agencyToUpdate.totalAttempts ? agencyToUpdate.totalAttempts : 0;

    // Transform nonMDMCustomer to string if needed
    if (agencyToUpdate.nonMDMCustomer !== undefined && agencyToUpdate.nonMDMCustomer !== null) {
      if (typeof agencyToUpdate.nonMDMCustomer === 'boolean') {
        agencyToUpdate.nonMDMCustomer = agencyToUpdate.nonMDMCustomer ? NonMDMCustomerEnum.Enabled : NonMDMCustomerEnum.Disabled;
      } else if (
        agencyToUpdate.nonMDMCustomer !== NonMDMCustomerEnum.NotSet &&
        agencyToUpdate.nonMDMCustomer !== NonMDMCustomerEnum.Enabled &&
        agencyToUpdate.nonMDMCustomer !== NonMDMCustomerEnum.Disabled
      ) {
        agencyToUpdate.nonMDMCustomer = NonMDMCustomerEnum.NotSet;
      }
    } else {
      agencyToUpdate.nonMDMCustomer = NonMDMCustomerEnum.NotSet;
    }

    if (this.currentUser.is_company_admin && this.currentUser.currentUserRole === RoleID.companyAdmin) {
      agencyToUpdate.companyId = this.currentUser.companyId;
    }

    if (this.currentUser.is_super_admin || this.currentUser.is_IOH_admin) {
      if (
        agencyToUpdate.companyId &&
        typeof agencyToUpdate.companyId !== "string" &&
        "label" in agencyToUpdate.companyId &&
        "value" in agencyToUpdate.companyId
      ) {
        agencyToUpdate.companyId = agencyToUpdate.companyId.value;
      }
    }

    this.subscriptions.push(
      this.agencyService.updateAgency(agencyToUpdate).subscribe(
        (res: any) => {
          // A refused save comes back as a normal response with success false, not as an HTTP error.
          if (res?.success === false) {
            this.messageHandlerService.generateToastMessage("error", "", this.refusalReason(res) || "Error In Updating Agency");
            return;
          }
          this.getAgencies();
          this.messageHandlerService.generateToastMessage("success", "", "Agency Updated Successfully");
          this.sideNavService.setEDocPurchase();
        },
        (error) => {
          this.messageHandlerService.generateToastMessage("error", "", "Error In Updating Agency");
        },
      ),
    );
  }

  onDropDownChange(index: number, selectedOption) {
    if (selectedOption === "Edit") {
      this.selectedIndex = this.agencies[index];
      this.showEditForm = true;
      this.display = true;
      this.prepareEditAgencyForm();
      this.createEditAgencyForm();
    } else if (selectedOption === "Delete") {
      this.selectedIndex = this.agencies[index];
      this.onDeleteClick();
    }
  }

  changeStatus(index: number) {
    let agency: Agency = { ...this.agencies[index] };
    agency.status = agency.status === "Active" ? "Inactive" : "Active";
    this.updateAgency(agency);
  }

  onAddAgencyClick() {
    this.showEditForm = false;
    this.display = true;
    this.resetEDocsUploadState();
    this.patientSigningDocuments = [];
    this.createAgencyForm();
  }

  paginate(event) {
    if (!this.isChangingPage) {
      this.utilService.setDataInLocalStorage("globalPageLimit", "perPage", event.rows);
      this.pageNo = event.page;
      this.noOfAgenciesPerRow = event.rows;
      this.getAgencies();
    }
  }

  changePage() {
    this.isChangingPage = true;
    setTimeout(() => {
      this.paginator.changePage(this.pageNo);
      this.isChangingPage = false;
    });
  }

  onChangeAgencyLevelFilter(event) {
    this.agencyLevelFilter = event.value;
    this.pageNo = 0;
    this.getAgencies();
    this.paginator.changePage(this.pageNo);
    this.utilService.setDataInLocalStorage(this.componentLocalStorageKey, "selectedAgencyLevel", this.selectedAgencyLevel);
  }

  onChangeAgencyStatusFilter(event) {
    this.agencyStatusFilter = event.value;
    this.pageNo = 0;
    this.getAgencies();
    this.paginator.changePage(this.pageNo);
    this.utilService.setDataInLocalStorage(this.componentLocalStorageKey, "selectedAgencyStatus", this.selectedAgencyStatus);
  }

  onChangeAppSettingValue(event: any, controlName: string) {
    this.addAgencyForm.patchValue({ appSettings: { [controlName]: event.checked } });
  }

  /**
   * DL Rules, and Care Compass (a paid feature, IOHB-2092), are shown to a Super Admin or IOH Admin only.
   * user-agency drops anyone else's Care Compass value and keeps the stored one.
   */
  isAppSettingShown(controlName: string): boolean {
    const adminOnly = ["mlRules", "showCareCompass"];
    return !adminOnly.includes(controlName) || !!(this.currentUser?.is_super_admin || this.currentUser?.is_IOH_admin);
  }

  onChangePortalFeatureValue(event: any, controlName: string) {
    this.addAgencyForm.patchValue({ portalFeatures: { [controlName]: event.checked } });
  }

  /**
   * The form only has controls for portalFeatureValues, so this starts from the stored map and sends
   * back the flags it has no toggle for. The user service no longer needs them (since IOHB-2037 a save
   * only changes the flags it names); they are still sent so a save behaves the same on a service not
   * yet on that change.
   */
  private getPortalFeaturesToSave(): Record<string, boolean> {
    return {
      ...(this.selectedIndex?.portalFeatures || {}),
      ...(this.addAgencyForm?.value?.portalFeatures || {}),
    };
  }

  /**
   * The toggles shown in Portal Features: superAdminOnly ones only to a Super Admin. The form still has their
   * controls, so a save by anyone else sends the stored value unchanged.
   */
  get visiblePortalFeatures(): PortalFeatures[] {
    return this.portalFeatures.filter((feature) => !feature.superAdminOnly || this.currentUser?.is_super_admin);
  }

  isEDocEnabled(): boolean {
    return !!this.addAgencyForm?.get("portalFeatures.eDoc")?.value;
  }

  private isIoDocEnabledOnAgency(agency: any): boolean {
    const v = agency?.portalFeatures?.eDoc;
    return v === true || v === "true";
  }

  /** When IO Doc is off, do not persist or display template bodies (avoids leaking create-form defaults). */
  private clearIoDocTemplatePayload(agency: any): void {
    agency.emailTemplates = {
      piTemplate: { email: { body: "" } },
      phTemplate: { email: { body: "" } },
      otherTemplate: { email: { body: "" } },
      esignTemplate: { email: { body: "" } },
      hosAddendumTemplate: { email: { body: "" } },
      hosAddendumOverdueTemplate: { email: { body: "" } },
    };
    agency.smsTemplates = {
      piTemplate: { sms: "" },
      phTemplate: { sms: "" },
      otherTemplate: { sms: "" },
      esignTemplate: { sms: "" },
      hosAddendumTemplate: { sms: "" },
      hosAddendumOverdueTemplate: { sms: "" },
    };
  }

  private getApiTemplateEmailBody(
    key: "piTemplate" | "phTemplate" | "otherTemplate" | "esignTemplate" | "hosAddendumTemplate" | "hosAddendumOverdueTemplate"
  ): string {
    if (!this.isIoDocEnabledOnAgency(this.selectedIndex)) {
      return "";
    }
    const v = this.selectedIndex?.emailTemplates?.[key]?.email?.body;
    if (typeof v === "string" && v.trim().length > 0) {
      return v;
    }
    return AGENCY_TEMPLATE_DEFAULT_EMAIL_BODIES[key] || "";
  }

  private getApiTemplateSms(
    key: "piTemplate" | "phTemplate" | "otherTemplate" | "esignTemplate" | "hosAddendumTemplate" | "hosAddendumOverdueTemplate"
  ): string {
    if (!this.isIoDocEnabledOnAgency(this.selectedIndex)) {
      return "";
    }
    const fromSmsBlock = this.selectedIndex?.smsTemplates?.[key]?.sms;
    if (typeof fromSmsBlock === "string" && fromSmsBlock.trim().length > 0) {
      return fromSmsBlock;
    }
    const fromEmailTemplates = this.selectedIndex?.emailTemplates?.[key]?.sms;
    if (typeof fromEmailTemplates === "string" && fromEmailTemplates.trim().length > 0) {
      return fromEmailTemplates;
    }
    return AGENCY_TEMPLATE_DEFAULT_SMS[key] || "";
  }

  private getEDocsUploadedDateDisplay(eDocsFile: any): string {
    if (!eDocsFile) return "";

    // Prefer explicit timestamps if present on API payload.
    const directTimestamp = eDocsFile.createdAt || eDocsFile.updatedAt || eDocsFile.uploadedAt;
    if (directTimestamp) {
      return this.datePipe.transform(directTimestamp, "MM-dd-yyyy hh:mm a") || "";
    }

    // Fallback: extract datetime from fileName pattern like "...-2026-03-10T08-18-06.827Z.pdf".
    const fileName = eDocsFile.fileName || "";
    const match = fileName.match(/(\d{4}-\d{2}-\d{2}T\d{2}-\d{2}-\d{2}(?:\.\d+)?Z)/);
    if (!match?.[1]) return "";

    const normalized = match[1].replace(
      /T(\d{2})-(\d{2})-(\d{2})/,
      (_full, h, m, s) => `T${h}:${m}:${s}`,
    );
    return this.datePipe.transform(normalized, "MM-dd-yyyy hh:mm a") || "";
  }

  checkNameAndAgencyNameInput() {
    this.showInvalidSMSTemplateError = this.addAgencyForm.get("SMSTemplate").value.length > 135;
  }

  checkEmailTemplateLength() {
    this.showInvalidEmailTemplateError = this.addAgencyForm.get("emailTemplate").value.length > 135;
  }

  checkDiagnosisGroupVisibility(event) {
    this.disableDiagnosisGroups = event.checked;
  }

  // The multiselect selects each option by its string value, but agencies come back with { name, value } groups
  // (or plain names for older ones), so they are turned into values before they reach the form.
  toDiagnosisGroupValues(groups: unknown): string[] {
    if (!Array.isArray(groups)) return [];
    return groups
      .map((group) => (typeof group === "string" ? group : group?.value ?? group?.name))
      .filter((value): value is string => typeof value === "string" && value.length > 0);
  }

  onExportData() {
    let agenciesToExportIds = this.utilService.getSelectedAgenciesIds(this.selectedAgenciesToExport);
    if (agenciesToExportIds && agenciesToExportIds.length === 0) {
      this.messageHandlerService.generateToastMessage("error", "", `Please select agencies to generate the report`);
      return;
    }

    const isValidDateRange = validateDateRange(this.dateRangeToExportAgencyData);
    if(!isValidDateRange){
      this.messageHandlerService.generateToastMessage("error", "", ALERT_TYPE_DATE_RANGE_SELECTION);
      return;
    }


    // if (!this.dateRangeToExportAgencyData?.startDate && !this.dateRangeToExportAgencyData?.endDate) {
    //    this.messageHandlerService.generateToastMessage("error", "", `Please select the Date range to generate the report`);
    //   return;
    // }




    let requestPayload = {
      agencyIds: this.getAllowedAgencyIds(agenciesToExportIds),
      searchByDate: this.dateRangeToExportAgencyData,
      sortBy: "",
    };

    this.getAgnecyDataToExport(requestPayload);
  }

  getAllowedAgencyIds(agenciesToExportIds) {
    if (this.agenciesAllowed && this.agenciesAllowed.length && this.agenciesAllowed[0] != undefined) {
      let agencyIds: string[] = [];
      agenciesToExportIds.forEach((obj) => {
        if (this.agenciesAllowed.includes(obj)) {
          agencyIds.push(obj);
        }
      });
      return agencyIds;
    } else {
      return agenciesToExportIds;
    }
  }

  setDatesForExport() {
    let startDateFilter: any = this.datePipe.transform(this.rangeDates[0], dateFormatStartWithYear);
    let endDateFilter: any = this.datePipe.transform(this.rangeDates[1], dateFormatStartWithYear);

    this.dateRangeToExportAgencyData = {
      startDate: this.utilService.convertDateFilterToISOString(startDateFilter, true),
      endDate: this.utilService.convertDateFilterToISOString(endDateFilter, false), // change false to true 7/6/2024
    };

    this.utilService.setDataInLocalStorage("globalDates", "startDate", this.rangeDates[0]);
    this.utilService.setDataInLocalStorage("globalDates", "endDate", this.rangeDates[1]);
  }

  onCalendarClear() {
    this.rangeDates = null;
    this.dateRangeToExportAgencyData = null;
    this.localStorageService.remove("globalDates");
  }

  getUniqueAndDupObject(array) {
    const uniqObjs = [];
    const dupeObjs = [];

    array.forEach((obj) =>
      [uniqObjs, dupeObjs][+(array.map((obj) => obj.companyId._id).filter((id) => id === obj.companyId._id).length > 1)].push(obj),
    );

    return {
      unique: uniqObjs,
      duplicate: dupeObjs,
    };
  }




  getAgnecyDataToExport(requestPayload) {
    this.agencyService.getAgencyErrorsAndWarningsDataToExport(requestPayload).subscribe(
      (res:any) => {
        if(res && res.success){
          this.messageHandlerService.generateToastMessage("success", "", res.message);
        }
      },
      (error) => {
        //this.messageHandlerService.generateToastMessage("error", "", `An error occurred ${error}`);
      },
    );
  }

  getReportHeadersForAgency() {
    return [
      { header: "", key: "", width: 25 },
      { header: "Agency", key: "Agency", width: 50 },
      { header: "Patients", key: "Patients", width: 20 },
      { header: "io Patients", key: "io Patients", width: 20 },
      { header: "io Visits", key: "io Visits", width: 20 },
      { header: "Errors", key: "Errors", width: 20 },
      { header: "Warnings", key: "Warnings", width: 20 },
      { header: "Consistency Warnings", key: "Consistency Warnings", width: 25 },
      { header: "Total Errors & Warnings", key: "Total Errors & Warnings", width: 35 },
      { header: "Total Errors & Warnings / io Visits", key: "Total Errors & Warnings / io Visits", width: 40 },
    ];
  }

  getReportHeadersForAgencyClinicians() {
    return [
      { header: "Clinician", key: "Clinician", width: 25 },
      { header: "Agency", key: "Agency", width: 50 },
      { header: "Patients", key: "Patients", width: 20 },
      { header: "io Patients", key: "io Patients", width: 20 },
      { header: "io Visits", key: "io Visits", width: 20 },
      { header: "Errors", key: "Errors", width: 20 },
      { header: "Warnings", key: "Warnings", width: 20 },
      { header: "Consistency Warnings", key: "Consistency Warnings", width: 25 },
      { header: "Total Errors & Warnings", key: "Total Errors & Warnings", width: 35 },
      { header: "Total Errors & Warnings / io Visits", key: "Total Errors & Warnings / io Visits", width: 40 },
    ];
  }

  getReportHeadersForAgencyDiagnosticGroups() {
    return [
      { header: "Diagnostic Group", key: "Diagnostic Group", width: 25 },
      { header: "Agency", key: "Agency", width: 50 },
      { header: "Patients", key: "Patients", width: 20 },
      { header: "io Patients", key: "io Patients", width: 20 },
      { header: "io Visits", key: "io Visits", width: 20 },
      { header: "Errors", key: "Errors", width: 20 },
      { header: "Warnings", key: "Warnings", width: 20 },
      { header: "Consistency Warnings", key: "Consistency Warnings", width: 25 },
      { header: "Total Errors & Warnings", key: "Total Errors & Warnings", width: 35 },
      { header: "Total Errors & Warnings / io Visits", key: "Total Errors & Warnings / io Visits", width: 40 },
    ];
  }

  getReportHeadersForDiagnosticGroups() {
    return [
      { header: "Diagnostic Group", key: "Diagnostic Group", width: 25 },
      { header: "Agency", key: "Agency", width: 50 },
      { header: "Total # Patients from dx group", key: "Total # Patients from dx group", width: 30 },
      { header: "Total # errors", key: "Total # errors", width: 20 },
      { header: "Total # warnings", key: "Total # warnings", width: 20 },
    ];
  }

  generateDiagnosticGroup(agencyData) {
    const newWorksheet = this.workbook.addWorksheet("Diagnostic Groups");
    this.addFilterDatesRow(newWorksheet, "warning");
    if (agencyData?.agencies && agencyData?.agencies[0] != undefined) {
      for (let agency of agencyData?.agencies) {
        this.prepareDiagnosticGroupWithHeaders(agency?.usersData[0]?.diagnosticGroupsData, agency.agencyName, agency.visits, newWorksheet);
      }
    }
  }

  generateExcelReportData(agencyData, worksheet) {
    this.addFilterDatesRow(worksheet, "warning");
    if (agencyData?.agencies && agencyData?.agencies[0] != undefined) {
      for (let agency of agencyData?.agencies) {
        this.prepareAgencyDatawithHeaders(agency, worksheet);
      }
    }
  }

  prepareDiagnosticGroupWithHeaders(data, agencyName, visits, worksheet) {
    this.addDiagnosticGroupHeaders(worksheet);
    this.addDiagnosticGroupData(data, agencyName, visits, worksheet);
  }

  addDiagnosticGroupHeaders(worksheet) {
    let headers = this.getReportHeadersForDiagnosticGroups();
    this.addHeaderRow(headers, worksheet);
  }

  addDiagnosticGroupData(diagnosisGroup, agencyName, visits, worksheet) {
    const mergeDiagnosticGroups = ["default", "other"];
    const mergeUnchangedDiagnosticGroups = ["default", "Other"];
    const filterDiagnosticGroups = diagnosisGroup.filter((dg) => mergeDiagnosticGroups.includes(dg?.group?.toLowerCase() ?? ""));

    const groupVisits = this.filterBy(visits, "group");

    let ungroup_dg = [];

    diagnosisGroup.forEach((obj) => {
      if (obj != 0 && !mergeDiagnosticGroups.includes(obj.group.toLowerCase())) {
        let diagnosisGroupData = {
          name: ERROR_WARNING_DIAGNOSTIC_GROUP_MAPPING.find((e) => e.group_values.includes(obj.group))?.group_name || obj?.group || "",
          agency_name: agencyName || "",
          ttlPatients: obj?.totalPatients || obj?.totalPatients === 0 ? obj?.totalPatients : "",
          error: groupVisits[obj?.group]?.error || "",
          warn: groupVisits[obj?.group]?.warn || "",
        };
        ungroup_dg.push(diagnosisGroupData);
      }
    });

    const groupEntries = groupBy(ungroup_dg, "name");

    for (const [k, v] of Object.entries(groupEntries)) {
      const name = k;
      const agency_name = v[0].agency_name;
      let ttlPatient = 0;
      let error = 0;
      let warning = 0;

      v.forEach((fdg) => {
        ttlPatient += fdg?.ttlPatients || fdg?.ttlPatients === 0 ? fdg?.ttlPatients : 0;
        error += fdg?.error || fdg?.error === 0 ? fdg?.error : 0;
        warning += fdg?.warn || fdg?.warn === 0 ? fdg?.warn : 0;
      });

      const r = [name, agency_name, ttlPatient, error, warning];

      worksheet.addRow(r);
    }

    if (filterDiagnosticGroups.length > 0) {
      let ttlPatient = 0;
      let error = 0;
      let warning = 0;

      filterDiagnosticGroups.forEach((fdg) => {
        ttlPatient += fdg?.totalPatients || fdg?.totalPatients === 0 ? fdg?.totalPatients : 0;
      });

      for (const v of mergeUnchangedDiagnosticGroups) {
        if (groupVisits[v]) {
          error += groupVisits[v].error;
          warning += groupVisits[v].warn;
        }
      }

      let diagnosisGroupData = ["Other", agencyName || "", ttlPatient, error, warning];
      worksheet.addRow(diagnosisGroupData);
    }

    this.addblankRows(worksheet);
  }

  prepareAgencyDatawithHeaders(agency, worksheet) {
    this.addAgencyHeaders(worksheet);
    this.addAgencyData(agency, worksheet);
  }

  addAgencyHeaders(worksheet) {
    let headers = this.getReportHeadersForAgency();
    this.addHeaderRow(headers, worksheet);
  }

  calculateInconsistencyWarnings(visits: any[]) {
    let crossRulesIssuesCount = 0;
    visits.forEach((visit) => {
      let crossRulesIssues = [];
      const issues = visit?.issues || [];

      issues.forEach((issue) => {
        if (issue?.crossRule && issue?.crossRuleType === "impact") {
          crossRulesIssues.push(issue);
        }
      });

      let handledIssues = [];

      for (let i = 0; i < crossRulesIssues.length; i++) {
        for (let j = 0; j < crossRulesIssues[i].otherValues.length; j++) {
          let id1 = crossRulesIssues[i].question + crossRulesIssues[i].otherValues[j].title;

          let id2 = crossRulesIssues[i].otherValues[j].title + crossRulesIssues[i].question;

          if (handledIssues.includes(id1) || handledIssues.includes(id2)) {
            continue;
          } else {
            handledIssues.push(id1);
            handledIssues.push(id2);
            crossRulesIssuesCount++;
          }
        }
      }
    });

    return crossRulesIssuesCount;
  }

  fetchAppLinks(): void {
    if (!OnlySuperAdminAllowedRoles.includes(this.currentUser?.currentUserRole)) {
      this.appLinks = [];
      this.appLinkOptions = [];
      return;
    }
    this.isFetchingAppLinks = true;
    this.appLinks = [];
    this.appLinkOptions = [];
    this.progressBarService.setProgressBarVisibility(true);
    this.appLinkService.getAll({ page: 1, limit: 999 }).pipe(
      finalize(() => {
        this.isFetchingAppLinks = false;
      })
    ).subscribe(
      (res: any) => {
        this.progressBarService.setProgressBarVisibility(false);
        if (res && res.success) {
          const rawData = Array.isArray(res.data)
            ? res.data
            : Array.isArray(res.content?.data)
              ? res.content.data
              : [];

          this.appLinks = rawData.map((item: any) => ({
            ...item,
            id: item._id || item.id,
          }));

          this.appLinkOptions = this.appLinks.map((app: AppLink) => ({
            label: `${app.name} - ${app.appVersion}`,
            value: app.id,
          }));

          this.selectLatestAppLink();
        } else {
          this.appLinks = [];
          this.appLinkOptions = [];
        }
      },
      (error) => {
        this.progressBarService.setProgressBarVisibility(false);
        this.appLinks = [];
        this.appLinkOptions = [];
        this.messageHandlerService.generateToastMessage("error", "", "Error fetching app links.");
      }
    );
  }

  private selectLatestAppLink(): void {
    if (this.selectedAppLinkId || !this.appLinks?.length) return;
    const latestId = this.getLatestAppLinkId(this.appLinks);
    if (latestId) {
      this.selectedAppLinkId = latestId;
    }
  }

  private getLatestAppLinkId(appLinks: AppLink[]): string | number | null {
    if (!appLinks?.length) return null;

    const parseVersion = (version?: string): number[] | null => {
      if (!version) return null;
      const parts = version.split(".").map((part) => Number(part));
      return parts.every((num) => !isNaN(num)) ? parts : null;
    };

    const sorted = [...appLinks].sort((a, b) => {
      const aParts = parseVersion(a.appVersion);
      const bParts = parseVersion(b.appVersion);

      if (aParts && bParts) {
        const maxLen = Math.max(aParts.length, bParts.length);
        for (let i = 0; i < maxLen; i++) {
          const aNum = aParts[i] || 0;
          const bNum = bParts[i] || 0;
          if (aNum !== bNum) return bNum - aNum; // higher version first
        }
      }

      const aDate = new Date(a.createdAt || 0).getTime();
      const bDate = new Date(b.createdAt || 0).getTime();
      return bDate - aDate; // newest first
    });

    return sorted[0]?.id || null;
  }

  sendBulkEmail() {
    if (this.isSendingAppLinkEmail) return;

    if (!OnlySuperAdminAllowedRoles.includes(this.currentUser?.currentUserRole)) {
      this.messageHandlerService.generateToastMessage("error", "", "Only Super Admin can send bulk email.");
      return;
    }

    if (!this.selectedAppLinkId) {
      this.messageHandlerService.generateToastMessage("error", "", "Please select an app link.");
      return;
    }

    const shouldUpdateNonMdm = this.shouldUpdateNonMdmBeforeSend();
    if (shouldUpdateNonMdm) {
      this.confirmationService.confirm({
        message: "Update Non-MDM customer setting to Enabled and send email?",
        header: "Confirm Update",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Update & Send",
        rejectLabel: "Cancel",
        accept: () => this.updateNonMdmAndSendBulkEmail(),
        reject: () => {},
      });
      return;
    }

    this.performSendBulkEmail();
  }

  private shouldUpdateNonMdmBeforeSend(): boolean {
    const backendNonMdm = this.normalizeNonMdmCustomerFromApi(this.selectedIndex?.nonMDMCustomer);
    const localNonMdm = this.addAgencyForm?.value?.nonMDMCustomer;
    return localNonMdm === NonMDMCustomerEnum.Enabled && backendNonMdm !== NonMDMCustomerEnum.Enabled;
  }

  private normalizeNonMdmCustomerFromApi(value: any): NonMDMCustomerEnum {
    if (value === NonMDMCustomerEnum.Enabled || value === true || value === "true") return NonMDMCustomerEnum.Enabled;
    if (value === NonMDMCustomerEnum.Disabled || value === false || value === "false") return NonMDMCustomerEnum.Disabled;
    return NonMDMCustomerEnum.NotSet;
  }

  private updateNonMdmAndSendBulkEmail(): void {
    const payload = this.buildAgencyNonMdmUpdatePayload();
    if (!payload) {
      this.messageHandlerService.generateToastMessage("error", "", "Unable to update Non-MDM before sending email.");
      return;
    }

    this.isSendingAppLinkEmail = true;
    this.progressBarService.setProgressBarVisibility(true);

    this.agencyService.updateAgency(payload).subscribe(
      (res: any) => {
        if (res?.success) {
          this.selectedIndex = {
            ...this.selectedIndex,
            nonMDMCustomer: NonMDMCustomerEnum.Enabled,
          };
          this.performSendBulkEmail(true);
        } else {
          this.isSendingAppLinkEmail = false;
          this.progressBarService.setProgressBarVisibility(false);
          this.messageHandlerService.generateToastMessage("error", "", res?.errorMessage || "Error in updating agency before sending email.");
        }
      },
      () => {
        this.isSendingAppLinkEmail = false;
        this.progressBarService.setProgressBarVisibility(false);
        this.messageHandlerService.generateToastMessage("error", "", "Error in updating agency before sending email.");
      },
    );
  }

  private buildAgencyNonMdmUpdatePayload(): Agency | null {
    if (!this.selectedIndex) return null;

    const payload: Agency = {
      ...this.selectedIndex,
      ...this.addAgencyForm?.value,
      portalFeatures: this.getPortalFeaturesToSave(),
      nonMDMCustomer: NonMDMCustomerEnum.Enabled,
    };

    payload.linkExpireDuration = payload.linkExpireDuration
      ? payload.linkExpireDuration
      : DEFAULT_AGENCY_EDOC_LINK_EXPIRATION_TIME;
    payload.totalAttempts = payload.totalAttempts ? payload.totalAttempts : 0;

    if (this.currentUser.is_company_admin && this.currentUser.currentUserRole === RoleID.companyAdmin) {
      payload.companyId = this.currentUser.companyId;
    } else if (this.currentUser.is_super_admin || this.currentUser.is_IOH_admin) {
      const companyId: any = (payload as any).companyId;
      if (companyId && typeof companyId !== "string" && "value" in companyId) {
        payload.companyId = companyId.value;
      }
    }

    this.sanitizeTemplatePayloadForApi(payload);
    return payload;
  }

  private performSendBulkEmail(alreadyLoading: boolean = false) {
    if (this.isSendingAppLinkEmail && !alreadyLoading) return;

    if (!alreadyLoading) {
      this.isSendingAppLinkEmail = true;
      this.progressBarService.setProgressBarVisibility(true);
    }

    if (!this.selectedIndex?.companyId?._id && !this.selectedIndex?.companyId) {
      this.isSendingAppLinkEmail = false;
      this.progressBarService.setProgressBarVisibility(false);
      this.messageHandlerService.generateToastMessage("error", "", "Company ID is required.");
      return;
    }

    const companyId = this.selectedIndex.companyId?._id || this.selectedIndex.companyId;
    const requestPayload = {
      companyId: companyId,
      agencyId: this.selectedIndex.id,
      apkId: this.selectedAppLinkId,
    };

    this.agencyService.sendBulkEmailToAgencies(requestPayload).subscribe(
      (res) => {
        this.isSendingAppLinkEmail = false;
        this.progressBarService.setProgressBarVisibility(false);
        if (res && res.success) {
          this.messageHandlerService.generateToastMessage("success", "", "Email sent successfully to agency.");
          this.getAgencies();
        }
      },
      () => {
        this.isSendingAppLinkEmail = false;
        this.progressBarService.setProgressBarVisibility(false);
        this.messageHandlerService.generateToastMessage("error", "", "Error in sending email to agency.");
      },
    );
  }

  calculateErrorsAndWarnings(visits: any[], type: "warn" | "error") {
    let count = 0;
    visits.forEach((visit) => {
      if (type === "error") {
        count += visit?.issues?.filter((e: any) => e.type === QUESTIONAIR_TYPE_ERROR && e.crossRuleType !== IMPACT).length;
      } else if (type === "warn") {
        count += visit?.issues?.filter(
          (e: any) => e.type === QUESTIONAIR_TYPE_WARN || (e.type === QUESTIONAIR_TYPE_WARNING && e.crossRuleType !== IMPACT),
        ).length;
      }
    });
    return count;
  }

  addAgencyData(agency, worksheet) {
    const IW = this.calculateInconsistencyWarnings(agency.visits);
    let agencyData = [
      "Total",
      agency.agencyName || "",
      agency.totalPatients || agency.totalPatients === 0 ? agency.totalPatients : "",
      agency.iohPatients || agency.iohPatients === 0 ? agency.iohPatients : "",
      agency.visits.length || 0,
      this.calculateErrorsAndWarnings(agency.visits, "error"),
      this.calculateErrorsAndWarnings(agency.visits, "warn"),
      IW || 0,
      Number.isNaN(this.calculateErrorsAndWarnings(agency.visits, "error") + this.calculateErrorsAndWarnings(agency.visits, "warn")) ? '' : (this.calculateErrorsAndWarnings(agency.visits, "error") + this.calculateErrorsAndWarnings(agency.visits, "warn")),
      Number.isNaN((this.calculateErrorsAndWarnings(agency.visits, "error") + this.calculateErrorsAndWarnings(agency.visits, "warn")) / agency.visits.length) ? '' : (this.calculateErrorsAndWarnings(agency.visits, "error") + this.calculateErrorsAndWarnings(agency.visits, "warn")) / agency.visits.length
    ];
    worksheet.addRow(agencyData);
    this.addblankRows(worksheet);
    if (agency.usersData && agency?.usersData[0]?.clinicians && agency?.usersData[0]?.clinicians[0] != undefined) {
      this.prepareAgencyCliniciansDatawithHeaders(agency?.usersData[0], agency.agencyName, agency.visits, worksheet);
    }

    if (agency.usersData && agency?.usersData[0]?.diagnosticGroupsData && agency?.usersData[0]?.diagnosticGroupsData[0] != undefined) {
      this.prepareAgencyDiagnosticGroupsDatawithHeaders(agency?.usersData[0]?.diagnosticGroupsData, agency.agencyName, agency.visits, worksheet);
    }
  }

  prepareAgencyCliniciansDatawithHeaders(clinicians, agencyName, visits, worksheet) {
    this.addAgencyCliniciansHeaders(worksheet);
    this.addAgencyCliniciansData(clinicians, agencyName, visits, worksheet);
  }

  addAgencyCliniciansHeaders(worksheet) {
    let headers = this.getReportHeadersForAgencyClinicians();
    this.addHeaderRow(headers, worksheet);
  }

  addAgencyCliniciansData(cliniciansData, agencyName, visits, worksheet) {
    const groupVisits = this.filterBy(visits, "userId");
    cliniciansData.clinicians.forEach((obj) => {
      let agencyCliniciansData = [
        obj.userName || "",
        agencyName || "",
        obj.totalPatientsForClinician || obj.totalPatientsForClinician === 0 ? obj.totalPatientsForClinician : "",
        obj.IOPatientsCount || obj.IOPatientsCount === 0 ? obj.IOPatientsCount : "",
        obj.totalUniqueSubmissionOfClinician || obj.totalUniqueSubmissionOfClinician === 0 ? obj.totalUniqueSubmissionOfClinician : "",
        groupVisits[obj?.userId]?.error || "",
        groupVisits[obj?.userId]?.warn || "",
        groupVisits[obj?.userId]?.inconsitency || "",
        Number.isNaN(groupVisits[obj?.userId]?.error + groupVisits[obj?.userId]?.warn) ? '' : (groupVisits[obj?.userId]?.error + groupVisits[obj?.userId]?.warn),
        Number.isNaN((groupVisits[obj?.userId]?.error + groupVisits[obj?.userId]?.warn) /  obj.totalUniqueSubmissionOfClinician) ? '' : (groupVisits[obj?.userId]?.error + groupVisits[obj?.userId]?.warn) /  obj.totalUniqueSubmissionOfClinician
      ];
      worksheet.addRow(agencyCliniciansData);
    });
    this.addblankRows(worksheet);
  }

  prepareAgencyDiagnosticGroupsDatawithHeaders(diagnosisGroups, agencyName, visits, worksheet) {
    this.addAgencyDiagnosticGroupHeaders(worksheet);
    this.addAgencyDiagnosticGroupsData(diagnosisGroups, agencyName, visits, worksheet);
  }

  addAgencyDiagnosticGroupHeaders(worksheet) {
    let headers = this.getReportHeadersForAgencyDiagnosticGroups();
    this.addHeaderRow(headers, worksheet);
  }

  filterBy(visits, field) {
    let inconsistencyWarnings = {};
    const groupVisits = groupBy(visits, field);

    for (const [k, v] of Object.entries(groupVisits)) {
      inconsistencyWarnings = {
        ...inconsistencyWarnings,
        [k]: {
          error: this.calculateErrorsAndWarnings(v, "error"),
          warn: this.calculateErrorsAndWarnings(v, "warn"),
          inconsitency: this.calculateInconsistencyWarnings(v),
        },
      };
    }

    return inconsistencyWarnings;
  }

  addAgencyDiagnosticGroupsData(diagnosisGroup, agencyName, visits, worksheet) {
    const mergeDiagnosticGroups = ["default", "other"];
    const mergeUnchangedDiagnosticGroups = ["default", "Other"];
    const filterDiagnosticGroups = diagnosisGroup.filter((dg) => mergeDiagnosticGroups.includes(dg?.group?.toLowerCase() ?? ""));

    const groupVisits = this.filterBy(visits, "group");

    diagnosisGroup.forEach((obj) => {
      if (obj != 0 && !mergeDiagnosticGroups.includes(obj?.group?.toLowerCase())) {
        let diagnosisGroupData = [
          obj?.group || "",
          agencyName || "",
          obj?.totalPatients || obj?.totalPatients === 0 ? obj?.totalPatients : "",
          obj?.totalIOHPatients || obj?.totalIOHPatients === 0 ? obj?.totalIOHPatients : "",
          obj?.diagnosticErrorsData.totalUniqueSubmissionsForGroup || obj?.diagnosticErrorsData.totalUniqueSubmissionsForGroup === 0
            ? obj?.diagnosticErrorsData.totalUniqueSubmissionsForGroup
            : "",
          groupVisits[obj?.group]?.error || "",
          groupVisits[obj?.group]?.warn || "",
          groupVisits[obj?.group]?.inconsitency || "",
          Number.isNaN(groupVisits[obj?.group]?.error + groupVisits[obj?.group]?.warn) ? '' : (groupVisits[obj?.group]?.error + groupVisits[obj?.group]?.warn),
          Number.isNaN((groupVisits[obj?.group]?.error + groupVisits[obj?.group]?.warn) / obj?.diagnosticErrorsData.totalUniqueSubmissionsForGroup) ? '' : (groupVisits[obj?.group]?.error + groupVisits[obj?.group]?.warn) / obj?.diagnosticErrorsData.totalUniqueSubmissionsForGroup
        ];
        worksheet.addRow(diagnosisGroupData);
      }
    });

    if (filterDiagnosticGroups.length > 0) {
      let ttlPatient = 0;
      let ttlioPatient = 0;
      let ttlioVisit = 0;
      let error = 0;
      let warning = 0;
      let inconsistencyWarning = 0;
      let ttlerrorwarning: number | string = 0;
      let ttlerrorwarning_iovisits: number | string = 0;

      filterDiagnosticGroups.forEach((fdg) => {
        ttlPatient += fdg?.totalPatients || fdg?.totalPatients === 0 ? fdg?.totalPatients : 0;
        ttlioPatient += fdg?.totalIOHPatients || fdg?.totalIOHPatients === 0 ? fdg?.totalIOHPatients : 0;
        ttlioVisit +=
          fdg?.diagnosticErrorsData.totalUniqueSubmissionsForGroup || fdg?.diagnosticErrorsData.totalUniqueSubmissionsForGroup === 0
            ? fdg?.diagnosticErrorsData.totalUniqueSubmissionsForGroup
            : 0;
      });

      for (const v of mergeUnchangedDiagnosticGroups) {
        if (groupVisits[v]) {
          error += groupVisits[v].error;
          warning += groupVisits[v].warn;
          inconsistencyWarning += groupVisits[v].inconsitency;
        }
      }

      ttlerrorwarning = Number.isNaN(error + warning) ? '' : (error + warning)
      ttlerrorwarning_iovisits = Number.isNaN((error + warning) / ttlioVisit) ? '' : ((error + warning) / ttlioVisit)

      let diagnosisGroupData = ["other", agencyName || "", ttlPatient, ttlioPatient, ttlioVisit, error, warning, inconsistencyWarning, ttlerrorwarning, ttlerrorwarning_iovisits];
      worksheet.addRow(diagnosisGroupData);
    }

    this.addblankRows(worksheet);
  }

  addblankRows(worksheet) {
    for (let i = 0; i <= 1; i++) {
      worksheet.addRow([]);
    }
  }

  getCompanyNameForReport() {
    let companyName;
    if (this.selectedAgenciesToExport && this.selectedAgenciesToExport.length) {
      const allHaveSameCompanyId = this.selectedAgenciesToExport.every(
        (obj) => obj?.companyId?._id === this.selectedAgenciesToExport[0]?.companyId?._id,
      );
      if (allHaveSameCompanyId) {
        companyName = this.selectedAgenciesToExport[0]?.companyId?.name;
      }
    }

    return companyName;
  }

  exportExcelReport() {
    void this.workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: EXCEL_TYPE });
      let titleString = "";
      if (this.selectedAgenciesToExport && this.selectedAgenciesToExport.length === 1) {
        titleString = `${this.selectedAgenciesToExport[0].name}-${ERROR_WARNING_REPORT_FILE_NAME}-`;
      } else if (this.selectedAgenciesToExport && this.selectedAgenciesToExport.length > 1) {
        const rArr = this.getUniqueAndDupObject(this.selectedAgenciesToExport);

        if (rArr.duplicate && rArr.duplicate.length > 0 && rArr.unique && rArr.unique.length <= 0) {
          titleString = `${this.selectedAgenciesToExport[0].companyId.name}-${ERROR_WARNING_REPORT_FILE_NAME}-`;
        } else if (rArr.unique && rArr.unique.length > 0) {
          titleString = `${ERROR_WARNING_REPORT_FILE_NAME}-`;
        }
      }
      fs.saveAs(blob, titleString + this.datePipe.transform(new Date(), dateFormatStartWithYearWithOutDashes) + EXCEL_EXTENSION);
    });
  }

  addHeaderRow(headers, worksheet) {
    const headerRowValues = headers?.map((obj) => obj.key);
    let headersRow = worksheet.addRow(headerRowValues);
    headersRow.eachCell((row, colNumber) => {
      row.style = {
        font: { bold: true },
        ...(colNumber !== 1
          ? {
              fill: {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFF00" },
                bgColor: { argb: "FFFF00" },
              },
            }
          : null),
      };
    });
    headers?.forEach((header, index) => {
      const column = worksheet.getColumn(index + 1); // Columns are 1-indexed
      column.width = header.width; // Set the width from the response
      column.alignment = { vertical: "middle", horizontal: "left" };
    });
  }

  addHeaderRowForUsers(worksheet) {
    const worksheetHeaders = this.getExcelReportHeadersForUsers();
    const headerRowValues = worksheetHeaders.map((obj) => obj.key);
    let headersRow = worksheet.addRow(headerRowValues);

    headersRow.eachCell((row, colNumber) => {
      row.style = {
        font: { bold: true },
        fill: {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFF00" },
          bgColor: { argb: "FFFF00" },
        },
      };
    });

    worksheetHeaders.forEach((header, index) => {
      const column = worksheet.getColumn(index + 1); // Columns are 1-indexed
      column.width = header.width; // Set the width from the response
      column.alignment = { vertical: "middle", horizontal: "left" };
    });
  }

  addHeaderRowForUserStatus(worksheet) {
    const worksheetHeaders = this.getExcelReportHeadersForUserStatus();
    const headerRowValues = worksheetHeaders.map((obj) => obj.key);
    let headersRow = worksheet.addRow(headerRowValues);

    headersRow.eachCell((row, colNumber) => {
      row.style = {
        font: { bold: true },
        fill: {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFF00" },
          bgColor: { argb: "FFFF00" },
        },
      };
    });

    worksheetHeaders.forEach((header, index) => {
      const column = worksheet.getColumn(index + 1); // Columns are 1-indexed
      column.width = header.width; // Set the width from the response
      column.alignment = { vertical: "middle", horizontal: "left" };
    });
  }

  addFilterDatesRow(worksheet, type: "user" | "warning" | "deleted") {
    let dateRangeString = "";
    let titleString = "";
    let filterRow;
    //const startDate = this.utilService.convertDateFilterToISOString(this.rangeDates[0],true);
    if (this.dateRangeToExportAgencyData?.startDate && !this.dateRangeToExportAgencyData?.endDate) {
      const startDate = this.datePipe.transform(this.rangeDates[0], dateFormatStartWithYear);
      const endDate = this.datePipe.transform(new Date().toISOString(), dateFormatStartWithYear); //this.utilService.convertDateFilterToISOString(new Date(),false);
      //this.datePipe.transform(new Date().toISOString(), dateFormatStartWithYear);
      dateRangeString = `Date Range: ${startDate} - ${endDate}`;
    } else if (this.dateRangeToExportAgencyData?.startDate && this.dateRangeToExportAgencyData?.endDate) {
      const startDate = this.datePipe.transform(this.rangeDates[0], dateFormatStartWithYear);
      const endDate = this.datePipe.transform(this.rangeDates[1], dateFormatStartWithYear); //
      dateRangeString = `Date Range: ${startDate} - ${endDate}`;
    } else if (!this.dateRangeToExportAgencyData?.startDate && !this.dateRangeToExportAgencyData?.endDate) {
      const startDate = this.datePipe.transform(new Date().toISOString(), dateFormatStartWithYear);
      dateRangeString = `Date Range: ---- - ${startDate}`;
    }

    if (this.selectedAgenciesToExport && this.selectedAgenciesToExport.length === 1) {
      if (type === "user") {
        titleString = `Report: ${this.selectedAgenciesToExport[0].name} - ${USER_DEVICES_REPORT_FILE_NAME}`;
      } else if (type === "warning") {
        titleString = `Report: ${this.selectedAgenciesToExport[0].name} - ${ERROR_WARNING_REPORT_FILE_NAME}`;
      } else if (type === "deleted") {
        titleString = `Report: ${this.selectedAgenciesToExport[0].name} - ${USER_STATUS_FILE_NAME}`;
      }
      //titleString = `Report: ${this.selectedAgenciesToExport[0].name} - ${type === 'user' ? USER_DEVICES_REPORT_FILE_NAME : ERROR_WARNING_REPORT_FILE_NAME}`
    } else if (this.selectedAgenciesToExport && this.selectedAgenciesToExport.length > 1) {
      const rArr = this.getUniqueAndDupObject(this.selectedAgenciesToExport);

      if (rArr.duplicate && rArr.duplicate.length > 0 && rArr.unique && rArr.unique.length <= 0) {
        //titleString = `Report: ${this.selectedAgenciesToExport[0].companyId.name} - ${type === 'user' ? USER_DEVICES_REPORT_FILE_NAME : ERROR_WARNING_REPORT_FILE_NAME}`
        if (type === "user") {
          titleString = `Report: ${this.selectedAgenciesToExport[0].companyId.name} - ${USER_DEVICES_REPORT_FILE_NAME}`;
        } else if (type === "warning") {
          titleString = `Report: ${this.selectedAgenciesToExport[0].companyId.name} - ${ERROR_WARNING_REPORT_FILE_NAME}`;
        } else if (type === "deleted") {
          titleString = `Report: ${this.selectedAgenciesToExport[0].companyId.name} - ${USER_STATUS_FILE_NAME}`;
        }
      } else if (rArr.unique && rArr.unique.length > 0) {
        //titleString = `Report: ${type === 'user' ? USER_DEVICES_REPORT_FILE_NAME : ERROR_WARNING_REPORT_FILE_NAME}`
        if (type === "user") {
          titleString = `Report: ${USER_DEVICES_REPORT_FILE_NAME}`;
        } else if (type === "warning") {
          titleString = `Report:  ${ERROR_WARNING_REPORT_FILE_NAME}`;
        } else if (type === "deleted") {
          titleString = `Report:  ${USER_STATUS_FILE_NAME}`;
        }
      }
    }

    filterRow = worksheet.addRow([titleString]);
    worksheet.mergeCells(`A${filterRow.number}:Z${filterRow.number}`);
    filterRow = worksheet.addRow([dateRangeString]);
    worksheet.mergeCells(`A${filterRow.number}:Z${filterRow.number}`);
    worksheet.addRow([]);
  }

  generateExcelReportDataForUserDevices(agencyData) {
    const exportData: any[] = [];
    if (agencyData) {
      for (let e of agencyData) {
        let exportRow = [
          e?.agency_roles && e?.agency_roles.length ? (e?.agency_roles[0]?.agency?.agencyName ?? "") : "",
          e?.firstName ?? "",
          e?.lastName ?? "",
          e?.provider ?? "",
          e?.status ?? "",
          e?.email ?? "",
          e?.is_company_admin ? this.companyAdmin : (e?.defaultRole ?? ""),
          e?.androidVersion ?? "",
          e?.desktopVersion ?? "",
          e?.platform ?? "",
          e?.lastLogin ? this.utilService.toLocal(e?.lastLogin, REPORT_TIME_ZONE) : "",
          e?.lastActivity ? this.utilService.toLocal(e?.lastActivity, REPORT_TIME_ZONE) : "",
          e?.lastAction ? this.utilService.toLocal(e?.lastAction, REPORT_TIME_ZONE) : "",
          e?.userSettings?.isMultiAgenciesAllowed ?? "",
          e?.createdByUsers[0] ? (e?.createdByUsers[0]?.firstName[0] + " " + e?.createdByUsers[0]?.lastName[0]) : "",
          e?.createdAt ? this.utilService.toLocal(e?.createdAt, REPORT_TIME_ZONE) : "",
          e?.userSettings?.logging ?? "",
          e?.userSettings?.loggingView ?? "",
          e?.permissions && e?.permissions.length ? e?.permissions.join(", ") : "",
          e?.PCV ?? "",
          e?.PCID ?? "",
          e?.PKID ?? "",
        ];
        exportData.push(exportRow);
      }
    }
    return exportData;
  }

  getExcelReportHeadersForUsers() {
    return [
      { header: "Agency", key: "Agency", width: 20 },
      { header: "FirstName", key: "FirstName", width: 30 },
      { header: "LastName", key: "LastName", width: 30 },
      { header: "ProviderType", key: "Provider Type", width: 15 },
      { header: "Status", key: "Status", width: 20 },
      { header: "Email", key: "Email", width: 50 },
      { header: "DefaultRole", key: "DefaultRole", width: 30 },
      { header: "Android Version", key: "Android Version", width: 20 },
      { header: "Desktop Version", key: "Desktop Version", width: 20 },
      { header: "Platform", key: "Platform", width: 20 },
      { header: "Last Login", key: "Last Login", width: 30 },
      { header: "Last Activity", key: "Last Activity", width: 30 },
      { header: "Last Action", key: "Last Action", width: 30 },
      { header: "Multi Agencies Allowed", key: "Multi Agencies Allowed", width: 20 },
      { header: "Created By", key: "Created By", width: 50 },
      { header: "Created At", key: "Created At", width: 30 },
      { header: "Logging", key: "Logging", width: 20 },
      { header: "Logging View", key: "Logging View", width: 20 },
      { header: "Permissions", key: "Permissions", width: 20 },
      { header: "PCV", key: "PCV", width: 20 },
      { header: "PCID", key: "PCID", width: 20 },
      { header: "PKID", key: "PKID", width: 20 },
    ];
  }

  exportExcelReportForUsers(dataToExport) {
    const companyName = this.getCompanyNameForReport();

    // creating workbook and worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet("User Devices");

    //adding filter dates row
    this.addFilterDatesRow(worksheet, "user");

    //adding header row
    this.addHeaderRowForUsers(worksheet);

    //adding data row
    worksheet.addRows(dataToExport);

    //writing data to excel file
    void workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: EXCEL_TYPE });
      fs.saveAs(
        blob,
        (this.selectedAgenciesToExport.length === 1
          ? `${this.selectedAgenciesToExport[0].name}-${USER_DEVICES_REPORT_FILE_NAME}`
          : companyName
            ? `${companyName}-${USER_DEVICES_REPORT_FILE_NAME}`
            : USER_DEVICES_REPORT_FILE_NAME) +
          "-" +
          this.datePipe.transform(new Date(), dateFormatStartWithYearWithOutDashes) +
          EXCEL_EXTENSION,
      );
    });
  }

  getAgencyUserDataToExport(requestPayload: any) {
    this.agencyService.getAgencyUsersAndDevicesDataToExport(requestPayload).subscribe(
      (res) => {
        if (res && res?.success) {
          this.messageHandlerService.generateToastMessage('success',"",res.message)
        } else if( res && !res?.success) {
          this.messageHandlerService.generateToastMessage("error", "", `No data matching the search criteria is found to export`);
        }
      },
      (error) => {
        // Error handling is centralized: ErrorInterceptor returns EMPTY for 403/400/500
        // (so this error handler won't be called for those), and ServiceClientService
        // suppresses "null where stream expected" errors. Only handle other unexpected errors.
        const errorMessage = error?.errorMessage || error?.message || error;
        this.messageHandlerService.generateToastMessage("error", "", `An error occurred ${errorMessage}`);
      },
    );
  }

  onExportUserInfo() {
    let agenciesToExportIds = this.utilService.getSelectedAgenciesIds(this.selectedAgenciesToExport);
    if (agenciesToExportIds && agenciesToExportIds.length === 0) {
      this.messageHandlerService.generateToastMessage("error", "", `Please select agencies to generate the report`);
      return;
    }
    let requestPayload = {
      agencyIds: this.getAllowedAgencyIds(agenciesToExportIds),
      searchByDate: this.dateRangeToExportAgencyData,
      sortBy: "",
      IOH: false,
    };

    this.getAgencyUserDataToExport(requestPayload);
  }

  isAgencyAdmin() {
    //if(this.currentUser.defaultRole == RoleID.AgencyAdmin) {
    this.currentUser?.agency_roles?.map((role) => {
      if (role.roles.includes(RoleID.AgencyAdmin)) {
        this.agenciesAllowed.push(role.agency.agencyID);
      }
    });
    // }
  }

  getReleaseVersion() {
    this.utilService.getReleaseVersion().subscribe((res) => {
      if (res && res.success) {
        if (res.content.data.version !== CURRENT_RELEASE_VERSION) {
          setInterval(() => {
            window.location.reload();
          }, RELOAD_PAGE_AFTER_RELEASE || 5000);
        }
      }
    });
  }

  onSelectedRowsChange() {
    let agencyListingRows = { selectedAgencyListingRows: [] };

    if (this.localStorageService.get("agencySettings")) agencyListingRows = JSON.parse(this.localStorageService.get("agencySettings"));

    agencyListingRows.selectedAgencyListingRows = this.selectedRows;
    this.localStorageService.set("agencySettings", JSON.stringify(agencyListingRows));
  }

  getSelectedRows() {
    if (!this.localStorageService.get("agencySettings")) {
      this.selectedRows = defaultSelectedAgencyRows;
      this.localStorageService.set("agencySettings", JSON.stringify({ selectedAgencyListingRows: this.selectedRows }));
    } else {
      this.selectedRows = JSON.parse(this.localStorageService.get("agencySettings"))?.selectedAgencyListingRows
        ? JSON.parse(this.localStorageService.get("agencySettings"))?.selectedAgencyListingRows
        : defaultSelectedAgencyRows;
    }
  }

  isRowVisible(rowName: string) {
    if (this.selectedRows && this.selectedRows.length) return this.selectedRows.find((selectedRow) => selectedRow === rowName);
  }

  onExportUserStatusReport() {
    let agenciesToExportIds = this.utilService.getSelectedAgenciesIds(this.selectedAgenciesToExport);
    if (agenciesToExportIds && agenciesToExportIds.length === 0) {
      this.messageHandlerService.generateToastMessage("error", "", `Please select agencies to generate the report`);
      return;
    }
    const isValidDateRange = validateDateRange(this.dateRangeToExportAgencyData);
    if(!isValidDateRange){
      this.messageHandlerService.generateToastMessage("error", "", ALERT_TYPE_DATE_RANGE_SELECTION);
      return;
    }
    // if (!this.dateRangeToExportAgencyData?.startDate && !this.dateRangeToExportAgencyData?.endDate) {
    //    this.messageHandlerService.generateToastMessage("error", "", `Please select the Date range to generate the report`);
    //   return;
    // }

    let requestPayload = {
      agencyIds: this.getAllowedAgencyIds(agenciesToExportIds),
      searchByDate: this.dateRangeToExportAgencyData,
    };

    this.getUserStatusDataToExport(requestPayload);
  }

  onExportUserActivationReport() {
    let agenciesToExportIds = this.utilService.getSelectedAgenciesIds(this.selectedAgenciesToExport);
    if (agenciesToExportIds && agenciesToExportIds.length === 0) {
      this.messageHandlerService.generateToastMessage("error", "", `Please select agencies to generate the report`);
      return;
    }

    const isValidDateRange = validateDateRange(this.dateRangeToExportAgencyData);
    if(!isValidDateRange){
      this.messageHandlerService.generateToastMessage("error", "", ALERT_TYPE_DATE_RANGE_SELECTION);
      return;
    }

    // if (!this.dateRangeToExportAgencyData?.startDate && !this.dateRangeToExportAgencyData?.endDate) {
    //    this.messageHandlerService.generateToastMessage("error", "", `Please select the Date range to generate the report`);
    //   return;
    // }
    let requestPayload = {
      agencyIds: this.getAllowedAgencyIds(agenciesToExportIds),
      searchByDate: this.dateRangeToExportAgencyData,
    };

    this.agencyService.getUserActivationReport(requestPayload).subscribe((res: any) => {
      if (res?.success) {
        this.messageHandlerService.generateToastMessage("success", "", res?.message);
      } else if(res && !res?.success) {
        this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + res.message);
      }
    });
  }

  onExportClinicianSuggestionCalculationReport() {
    let agenciesToExportIds = this.utilService.getSelectedAgenciesIds(this.selectedAgenciesToExport);
    if (agenciesToExportIds && agenciesToExportIds.length === 0) {
      this.messageHandlerService.generateToastMessage("error", "", `Please select agencies to generate the report`);
      return;
    }

    const isValidDateRange = validateDateRange(this.dateRangeToExportAgencyData);
    if(!isValidDateRange){
      this.messageHandlerService.generateToastMessage("error", "", ALERT_TYPE_DATE_RANGE_SELECTION);
      return;
    }

    // if (!this.dateRangeToExportAgencyData?.startDate && !this.dateRangeToExportAgencyData?.endDate) {
    //    this.messageHandlerService.generateToastMessage("error", "", `Please select the Date range to generate the report`);
    //   return;
    // }
    let requestPayload = {
      agencyIds: this.getAllowedAgencyIds(agenciesToExportIds),
      searchByDate: this.dateRangeToExportAgencyData,
    };

    this.agencyService.getClinicianSuggestionCalculateReportData(requestPayload).subscribe((res: any) => {
      if (res.success) {
        this.messageHandlerService.generateToastMessage("success", "", res.message);
      } else {
        this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + res.message);
      }
    });
  }

  onExportIOAlertReport(){
    try {
      let agenciesToExportIds = this.utilService.getSelectedAgenciesIds(this.selectedAgenciesToExport);
      if (agenciesToExportIds && agenciesToExportIds.length === 0) {
        this.messageHandlerService.generateToastMessage("error", "", `Please select agencies to generate the report`);
        return;
      }

    const isValidDateRange = validateDateRange(this.dateRangeToExportAgencyData);
    if(!isValidDateRange){
      this.messageHandlerService.generateToastMessage("error", "", ALERT_TYPE_DATE_RANGE_SELECTION);
      return;
    }

      // if (!this.dateRangeToExportAgencyData?.startDate && !this.dateRangeToExportAgencyData?.endDate) {
      //   this.messageHandlerService.generateToastMessage("error", "", `Please select the Date range to generate the report`);
      //   return;
      // }
      let requestPayload = {
        agencyIds: this.getAllowedAgencyIds(agenciesToExportIds),
        searchByDate: this.dateRangeToExportAgencyData,
      };

      this.agencyService.processIOAlertReport(requestPayload).subscribe((res: any) => {
        if (res?.success) {
          this.messageHandlerService.generateToastMessage("success", "", res?.message);
        } else {
          if(res && res?.message){
            this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + res?.message);
          }
        }
      });
    }catch (e) {
      this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + e?.message);
    }

  }

  downloadWarningsReport(){
    try {
      let agenciesToExportIds = this.utilService.getSelectedAgenciesIds(this.selectedAgenciesToExport);
      if (agenciesToExportIds && agenciesToExportIds.length === 0) {
        this.messageHandlerService.generateToastMessage("error", "", `Please select agencies to generate the report`);
        return;
      }

    const isValidDateRange = validateDateRange(this.dateRangeToExportAgencyData);
    if(!isValidDateRange){
      this.messageHandlerService.generateToastMessage("error", "", ALERT_TYPE_DATE_RANGE_SELECTION);
      return;
    }

      // if(!this.dateRangeToExportAgencyData?.startDate && !this.dateRangeToExportAgencyData?.endDate){
      //   this.messageHandlerService.generateToastMessage("error", "", `Please select date range to generate the report`);
      //   return;
      // }
      let requestPayload = {
        agencyIds: this.getAllowedAgencyIds(agenciesToExportIds),
        searchByDate: this.dateRangeToExportAgencyData,
      };

      this.agencyService.processWarningsReport(requestPayload).subscribe((res: any) => {
        if (res?.success) {
          this.messageHandlerService.generateToastMessage("success", "", res?.message);
        } else {
          if(res && res?.message){
            this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + res?.message);
          }
        }
      });
    }catch (e) {
      this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + e?.message);
    }
  }

  downloadPopupReport(){
    try {
      let agenciesToExportIds = this.utilService.getSelectedAgenciesIds(this.selectedAgenciesToExport);
      if (agenciesToExportIds && agenciesToExportIds.length === 0) {
        this.messageHandlerService.generateToastMessage("error", "", `Please select agencies to generate the report`);
        return;
      }

    const isValidDateRange = validateDateRange(this.dateRangeToExportAgencyData);
    if(!isValidDateRange){
      this.messageHandlerService.generateToastMessage("error", "", ALERT_TYPE_DATE_RANGE_SELECTION);
      return;
    }

      // if(!this.dateRangeToExportAgencyData?.startDate && !this.dateRangeToExportAgencyData?.endDate){
      //   this.messageHandlerService.generateToastMessage("error", "", `Please select date range to generate the report`);
      //   return;
      // }
      let requestPayload = {
        agencyIds: this.getAllowedAgencyIds(agenciesToExportIds),
        searchByDate: this.dateRangeToExportAgencyData,
      };

      this.agencyService.processPopupReport(requestPayload).subscribe((res: any) => {
        if (res?.success) {
          this.messageHandlerService.generateToastMessage("success", "", res?.message);
        } else {
          if(res && res?.message){
            this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + res?.message);
          }
        }
      });
    }catch (e) {
      this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + e?.message);
    }
  }

  downloadOasisReport(){
    try {
      let agenciesToExportIds = this.utilService.getSelectedAgenciesIds(this.selectedAgenciesToExport);
      if (agenciesToExportIds && agenciesToExportIds.length === 0) {
        this.messageHandlerService.generateToastMessage("error", "", `Please select agencies to generate the report`);
        return;
      }

    const isValidDateRange = validateDateRange(this.dateRangeToExportAgencyData);
    if(!isValidDateRange){
      this.messageHandlerService.generateToastMessage("error", "", ALERT_TYPE_DATE_RANGE_SELECTION);
      return;
    }

      // if(!this.dateRangeToExportAgencyData?.startDate && !this.dateRangeToExportAgencyData?.endDate){
      //   this.messageHandlerService.generateToastMessage("error", "", `Please select date range to generate the report`);
      //   return;
      // }
      let requestPayload = {
        agencyIds: this.getAllowedAgencyIds(agenciesToExportIds),
        searchByDate: this.dateRangeToExportAgencyData,
      };

      this.agencyService.processOasisReport(requestPayload).subscribe((res: any) => {
        if (res?.success) {
          this.messageHandlerService.generateToastMessage("success", "", res?.message);
        } else {
          if(res && res?.message){
            this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + res?.message);
          }
        }
      });
    }catch (e) {
      this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + e?.message);
    }
  }

  downloadAgencyComparisonReport(){
    try {
      let agenciesToExportIds = this.utilService.getSelectedAgenciesIds(this.selectedAgenciesToExport);
      if (agenciesToExportIds && agenciesToExportIds.length === 0) {
        this.messageHandlerService.generateToastMessage("error", "", `Please select agencies to generate the report`);
        return;
      }
       const isValidDateRange = validateDateRange(this.dateRangeToExportAgencyData);
       if(!isValidDateRange){
         this.messageHandlerService.generateToastMessage("error", "", ALERT_TYPE_DATE_RANGE_SELECTION);
         return;
       }
      // if(!this.dateRangeToExportAgencyData?.startDate && !this.dateRangeToExportAgencyData?.endDate){
      //   this.messageHandlerService.generateToastMessage("error", "", `Please select date range to generate the report`);
      //   return;
      // }
      let requestPayload = {
        agencyIds: this.getAllowedAgencyIds(agenciesToExportIds),
        searchByDate: this.dateRangeToExportAgencyData,
      };

      this.agencyService.processAgencyComparisonReport(requestPayload).subscribe((res: any) => {
        if (res?.success) {
          this.messageHandlerService.generateToastMessage("success", "", res?.message);
        } else {
          if(res && res?.message){
            this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + res?.message);
          }
        }
      });
    }catch (e) {
      this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + e?.message);
    }
  }

  downloadClinicianAnalysisReport(){
    try {
      let agenciesToExportIds = this.utilService.getSelectedAgenciesIds(this.selectedAgenciesToExport);
      if (agenciesToExportIds && agenciesToExportIds.length === 0) {
        this.messageHandlerService.generateToastMessage("error", "", `Please select agencies to generate the report`);
        return;
      }
      const isValidDateRange = validateDateRange(this.dateRangeToExportAgencyData);
      if(!isValidDateRange){
        this.messageHandlerService.generateToastMessage("error", "", ALERT_TYPE_DATE_RANGE_SELECTION);
        return;
      }

      // if(!this.dateRangeToExportAgencyData?.startDate && !this.dateRangeToExportAgencyData?.endDate){
      //   this.messageHandlerService.generateToastMessage("error", "", `Please select date range to generate the report`);
      //   return;
      // }
      let requestPayload = {
        agencyIds: this.getAllowedAgencyIds(agenciesToExportIds),
        searchByDate: this.dateRangeToExportAgencyData,
      };

      this.agencyService.processClinicianAnalysisReport(requestPayload).subscribe((res: any) => {
        if (res?.success) {
          this.messageHandlerService.generateToastMessage("success", "", res?.message);
        } else {
          if(res && res?.message){
            this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + res?.message);
          }
        }
      });
    }catch (e) {
      this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + e?.message);
    }
  }

  getUserStatusDataToExport(requestPayload) {
    this.agencyService.getUserStatusDataToExport(requestPayload).subscribe(
      (res: any) => {
        if (res && res?.success) {
          this.messageHandlerService.generateToastMessage("success", "", res?.message);
        } else if(res && !res?.success) {
          this.messageHandlerService.generateToastMessage("error", "", `An error occurred: ${res?.message}`);
        }
      },
      (error) => {
        //this.messageHandlerService.generateToastMessage("error", "", `An error occurred ${error}`);
      },
    );
  }

  generateExcelReportDataForDeletedAndInactiveUsers(data) {
    let dataToExport = [];
    if (data) {
      for (let e of data) {
        const name = e?.firstName + " " + e?.lastName;
        const status = e?.deleted ? "Deleted" : e?.status === "Inactive" ? "Inactive" : "";
        const deletedBy = e?.deletedBy ?  e?.deletedBy.split("~")[0] : "";
        let row = [
          name,
          e?.email ?? "",
          e?.agency_roles && e?.agency_roles.length ? (e?.agency_roles[0]?.agency?.agencyName ?? "") : "",
          e?.agency_roles && e?.agency_roles.length ? (RoleNames[e?.agency_roles[0]?.roles[0]] ?? "") : "",
          status,
          e?.deletedAt ? this.utilService.toLocal(e?.deletedAt, REPORT_TIME_ZONE) : "",
          e?.deletedBy ? deletedBy : "",
        ];
        dataToExport.push(row);
      }
    }
    return dataToExport;
  }

  exportExcelReportForUserStatus(dataToExport) {
    const companyName = this.getCompanyNameForReport();

    // creating workbook and worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(USER_STATUS_REPORT_FILE_TITLE);

    //adding filter dates row
    this.addFilterDatesRow(worksheet, "deleted");

    //adding header row
    this.addHeaderRowForUserStatus(worksheet);

    //adding data row
    worksheet.addRows(dataToExport);

    //writing data to excel file
    void workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: EXCEL_TYPE });
      fs.saveAs(
        blob,
        (this.selectedAgenciesToExport.length === 1
          ? `${this.selectedAgenciesToExport[0].name}-${USER_STATUS_REPORT_FILE_NAME}`
          : companyName
            ? `${companyName}-${USER_STATUS_REPORT_FILE_NAME}`
            : USER_STATUS_REPORT_FILE_NAME) +
          this.datePipe.transform(new Date(), dateFormatStartWithYearWithOutDashes) +
          EXCEL_EXTENSION,
      );
    });
  }

  getExcelReportHeadersForUserStatus() {
    return [
      { key: "User Name", header: "FirstName", width: 30 },
      { key: "Email", header: "Email", width: 30 },
      { key: "Agency", header: "Agency", width: 20 },
      { key: "Role", header: "DefaultRole", width: 30 },
      { key: "Status", header: "status", width: 30 },
      { key: "Date Action Occurred", header: "deletedAt", width: 20 },
      { key: "Deleted By", header: "deletedBy", width: 30 },
    ];
  }

  private initializeDropdownLabelPreservation(): void {
    // Ensure the dropdown label is hidden and "Generate Reports" is always shown
    setTimeout(() => {
      const exportReportDropdown = document.querySelector('.export-report .p-dropdown');
      if (exportReportDropdown) {
        // Hide the dropdown label
        const dropdownLabel = exportReportDropdown.querySelector('.p-dropdown-label');
        if (dropdownLabel) {
          (dropdownLabel as HTMLElement).style.display = 'none';
          (dropdownLabel as HTMLElement).style.visibility = 'hidden';
          (dropdownLabel as HTMLElement).style.opacity = '0';
        }

        // Hide the chevron down icon (dropdown trigger)
        const dropdownTrigger = exportReportDropdown.querySelector('.p-dropdown-trigger');
        if (dropdownTrigger) {
          (dropdownTrigger as HTMLElement).style.display = 'none';
          (dropdownTrigger as HTMLElement).style.visibility = 'hidden';
          (dropdownTrigger as HTMLElement).style.opacity = '0';
        }
      }
    }, 100);
  }

  private resetDropdownDisplay(): void {
    // Reset the dropdown selection to null to prevent selected value from showing
    if (this.reportDropdown) {
      this.reportDropdown.selectedOption = null;
      this.reportDropdown.value = null;
      //this.reportDropdown.updateLabel();
    }

    // Additional DOM manipulation to ensure label and chevron icon are hidden
    setTimeout(() => {
      const exportReportDropdown = document.querySelector('.export-report .p-dropdown');
      if (exportReportDropdown) {
        // Hide the dropdown label
        const dropdownLabel = exportReportDropdown.querySelector('.p-dropdown-label');
        if (dropdownLabel) {
          (dropdownLabel as HTMLElement).style.display = 'none';
          (dropdownLabel as HTMLElement).style.visibility = 'hidden';
          (dropdownLabel as HTMLElement).style.opacity = '0';
        }

        // Hide the chevron down icon (dropdown trigger)
        const dropdownTrigger = exportReportDropdown.querySelector('.p-dropdown-trigger');
        if (dropdownTrigger) {
          (dropdownTrigger as HTMLElement).style.display = 'none';
          (dropdownTrigger as HTMLElement).style.visibility = 'hidden';
          (dropdownTrigger as HTMLElement).style.opacity = '0';
        }
      }
    }, 0);
  }

  onExportUserActivityReport() {
    let agenciesToExportIds = this.utilService.getSelectedAgenciesIds(this.selectedAgenciesToExport);
    if (agenciesToExportIds && agenciesToExportIds.length === 0) {
      this.messageHandlerService.generateToastMessage("error", "", `Please select agencies to generate the report`);
      return;
    }

    const isValidDateRange = validateDateRange(this.dateRangeToExportAgencyData);
    if(!isValidDateRange){
      this.messageHandlerService.generateToastMessage("error", "", ALERT_TYPE_DATE_RANGE_SELECTION);
      return;
    }

    // if (!this.dateRangeToExportAgencyData?.startDate && !this.dateRangeToExportAgencyData?.endDate) {
    //    this.messageHandlerService.generateToastMessage("error", "", `Please select the Date range to generate the report`);
    //   return;
    // }
    let requestPayload = {
      agencyIds: this.getAllowedAgencyIds(agenciesToExportIds),
      searchByDate: this.dateRangeToExportAgencyData,
    };

    this.agencyService.getClinicianChangeReportData(requestPayload).subscribe((res: any) => {
      if (res?.success) {
        // const link = document.createElement("a");
        // link.href = res.content.fileName;
        // link.download = res.content.fileName;
        // link.click();
        this.messageHandlerService.generateToastMessage("success", "", res?.message);
      } else {
        this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + res.message);
      }
    });
  }

  // ==========================================
  // Automated Merged Document Delivery Methods
  // ==========================================

  /** The agency whose edit form is open. */
  private openAgencyId(): string {
    return this.selectedIndex?._id || this.selectedIndex?.id;
  }

  /**
   * The delivery settings only apply when the agency's company has HOS Addendum on, so that is asked
   * first. An agency without it neither shows the panel nor calls routes that are not there for it -
   * which, on an environment whose patient service is older than this screen, answered every agency
   * edit with an error.
   */
  private openDeliverySettings(agencyId: string): void {
    this.deliveryDestinations = [];
    this.deliverySettingsAvailable = false;
    this.deliverySettingsUnreachable = false;
    if (!agencyId) return;
    this.hosAddendumService.checkHosAddendumEnabled(agencyId).subscribe({
      next: (res: any) => {
        if (agencyId !== this.openAgencyId()) return;
        this.deliverySettingsAvailable = res?.content?.hosAddendumEnabled === true;
        if (this.deliverySettingsAvailable) {
          this.loadDeliveryDestinations(agencyId);
        }
      },
      error: (err: any) => {
        if (agencyId !== this.openAgencyId()) return;
        this.deliverySettingsAvailable = false;
        // Down or unreachable, not "this agency does not have it". A 404 stays quiet: that is a
        // patient service older than this screen.
        this.deliverySettingsUnreachable = err?.status === 0 || err?.status >= 500;
      },
    });
  }

  /** Asks again for the open agency, from the notice shown when the settings could not be reached. */
  retryDeliverySettings(): void {
    this.openDeliverySettings(this.openAgencyId());
  }

  loadDeliveryDestinations(agencyId: string): void {
    if (!agencyId) return;
    this.loadingDeliveryDestinations = true;
    this.hosAddendumService
      .listDeliveryDestinations(agencyId)
      .pipe(
        finalize(() => {
          this.loadingDeliveryDestinations = false;
        }),
      )
      .subscribe({
        next: (res: any) => {
          // Answers can arrive out of order. One for an agency that is no longer open is dropped:
          // applied, it showed that agency's fax and email on this one, and Verify, Delete and the
          // switches then acted on them under the wrong agency.
          if (agencyId !== this.openAgencyId()) return;
          this.deliveryDestinations = res?.data || res || [];
          // The verify popup keeps the destination it opened with. It is swapped for the reloaded one,
          // so the failed-attempt count it shows is the server's, not the one from when it opened.
          if (this.selectedDestination?._id) {
            this.selectedDestination =
              this.deliveryDestinations.find((d: any) => d._id === this.selectedDestination._id) ??
              this.selectedDestination;
          }
        },
        error: (err: any) => {
          if (agencyId !== this.openAgencyId()) return;
          // No such route: the patient service here is older than this screen. The settings are not
          // available yet, which is not something to raise an error about on every agency edit.
          if (err?.status === 404) {
            this.deliverySettingsAvailable = false;
            return;
          }
          this.messageHandlerService.generateToastMessage(
            "error",
            "Error",
            err?.error?.message || "Failed to load delivery destinations",
          );
        },
      });
  }

  /**
   * The address a channel is actually delivering to. An agency has one addendum email and one
   * addendum fax, and only a verified value is ever in use.
   */
  destinationInUse(channel: "EMAIL" | "FAX"): any {
    return (
      this.deliveryDestinations.find(
        (d: any) => d.channel === channel && d.status === "VERIFIED",
      ) || null
    );
  }

  /**
   * A value entered for a channel that has not proved itself yet. It is not delivering to anything:
   * whatever was already in use carries on until this one verifies, and only then replaces it.
   */
  destinationPending(channel: "EMAIL" | "FAX"): any {
    return (
      this.deliveryDestinations.find(
        (d: any) => d.channel === channel && d.status !== "VERIFIED",
      ) || null
    );
  }

  /**
   * The slot's one button. "Change" as soon as the channel holds any address, verified or not - with
   * one still waiting to be verified it read "Set", as though nothing had been entered.
   */
  destinationActionLabel(channel: "EMAIL" | "FAX"): string {
    return this.destinationInUse(channel) || this.destinationPending(channel) ? "Change" : "Set";
  }

  /**
   * An address as it is shown. A fax number is stored as typed, so ten digits came back as a bare run
   * of ten digits; a US number is shown the way it is written. Anything else is left as it is.
   */
  displayDestination(destination: any): string {
    const value = String(destination?.value ?? "");
    if (destination?.channel !== "FAX") {
      return value;
    }
    const digits = value.replace(/\D/g, "");
    const national = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
    return national.length === 10
      ? `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`
      : value;
  }

  /**
   * Keeps only the digits of what was typed or pasted. The code is shown in two groups ("526 270"),
   * so a paste brought the gap with it and the field's six-character limit then cut the last digit
   * off: five digits went in, the button lit up, and an attempt was spent on a code that could not be
   * right.
   */
  onVerificationCodeInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = (input.value || "").replace(/\D/g, "").slice(0, 6);
    if (input.value !== digits) {
      input.value = digits;
    }
    this.verificationCodeInput = digits;
  }

  openAddDeliveryDestinationModal(channel?: "EMAIL" | "FAX"): void {
    this.destinationChannel = channel || "EMAIL";
    // Opened from a slot, the channel is that slot's: the Fax slot sets the fax and nothing else.
    this.destinationChannelLocked = !!channel;
    this.destinationValue = "";
    this.addDestinationDialogVisible = true;
  }

  /** Whether the dialog's channel is fixed by the slot it was opened from. */
  destinationChannelLocked = false;

  /**
   * The channel values are the API's own, "EMAIL" and "FAX". The dialog compared against "fax", so a
   * fax number was always labelled and prompted as an email address.
   */
  get destinationIsFax(): boolean {
    return this.destinationChannel === "FAX";
  }

  /** The example shown in the dialog, from the same list that describes each slot. */
  get destinationPlaceholder(): string {
    return this.deliveryChannels.find((c) => c.key === this.destinationChannel)?.placeholder || "";
  }

  submitAddDeliveryDestination(): void {
    const agencyId = this.selectedIndex?._id || this.selectedIndex?.id;
    if (!agencyId || !this.destinationValue.trim()) return;

    this.savingDestination = true;
    this.hosAddendumService
      .createDeliveryDestination(agencyId, {
        channel: this.destinationChannel,
        value: this.destinationValue.trim(),
      })
      .pipe(
        finalize(() => {
          this.savingDestination = false;
        }),
      )
      .subscribe({
        next: (res: any) => {
          this.messageHandlerService.generateToastMessage(
            "success",
            "Success",
            "Delivery destination added successfully. Please verify it before enabling delivery.",
          );
          this.addDestinationDialogVisible = false;
          // Shown at once, rather than the slot saying "Not set" until the list reloads. It replaces
          // any earlier unverified address on the channel, as the server does.
          const added = res?.data;
          if (added?.channel) {
            this.deliveryDestinations = [
              ...(this.deliveryDestinations || []).filter(
                (d: any) => d.channel !== added.channel || d.status === "VERIFIED",
              ),
              added,
            ];
          }
          this.loadDeliveryDestinations(agencyId);
        },
        error: (err: any) => {
          this.messageHandlerService.generateToastMessage(
            "error",
            "Error",
            err?.error?.message || "Failed to add delivery destination",
          );
        },
      });
  }

  confirmDeleteDeliveryDestination(dest: any): void {
    this.confirmationService.confirm({
      message: `Are you sure you want to remove ${dest.channel?.toUpperCase()} destination: ${dest.value}?`,
      header: "Remove Delivery Destination?",
      icon: "pi pi-trash",
      acceptLabel: "Delete",
      rejectLabel: "Cancel",
      acceptButtonStyleClass: "btn-delete",
      accept: () => {
        this.deleteDeliveryDestination(dest);
      },
    });
  }

  deleteDeliveryDestination(dest: any): void {
    const agencyId = this.selectedIndex?._id || this.selectedIndex?.id;
    if (!agencyId || !dest?._id) return;

    this.hosAddendumService.deleteDeliveryDestination(agencyId, dest._id).subscribe({
      next: () => {
        this.messageHandlerService.generateToastMessage(
          "success",
          "Success",
          "Delivery destination removed successfully",
        );
        this.loadDeliveryDestinations(agencyId);
      },
      error: (err: any) => {
        this.messageHandlerService.generateToastMessage(
          "error",
          "Error",
          err?.error?.message || "Failed to delete delivery destination",
        );
      },
    });
  }

  openVerifyDestinationModal(dest: any): void {
    this.selectedDestination = dest;
    this.verificationCodeInput = "";
    this.requestCodeButtonLabel = "Send Verification Code";
    // A code sent earlier may still be running: pick up its countdown from the server's own expiry.
    const pendingUntil = dest?.codeExpiresAt ? new Date(dest.codeExpiresAt).getTime() : Number.NaN;
    if (Number.isFinite(pendingUntil) && pendingUntil > Date.now()) {
      this.requestCodeButtonLabel = "Resend Code";
      this.startCodeCountdown(pendingUntil);
    } else {
      this.stopCodeCountdown();
    }
    this.verifyDestinationDialogVisible = true;
  }

  /** When the code on screen stops working, as a timestamp. Null until a code has been sent. */
  codeExpiresAtMs: number | null = null;
  /** Whole seconds left on that code, refreshed every second while it runs. */
  codeSecondsLeft = 0;
  private codeCountdownTimer: ReturnType<typeof setInterval> | null = null;

  /** mm:ss, for the popup. */
  get codeCountdownLabel(): string {
    const s = Math.max(0, this.codeSecondsLeft);
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
  }

  get codeHasExpired(): boolean {
    return this.codeExpiresAtMs !== null && this.codeSecondsLeft <= 0;
  }

  /**
   * Counts down to the moment the code stops working. Product, 30 Sep: "visible countdown for the
   * verification code expiry against timestamp of code sent". The server refuses the code after this
   * moment, so the popup says so instead of letting someone type a code that can no longer work.
   */
  private startCodeCountdown(expiresAt: number): void {
    this.stopCodeCountdown();
    this.codeExpiresAtMs = expiresAt;
    const tick = () => {
      this.codeSecondsLeft = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
      if (this.codeSecondsLeft <= 0 && this.codeCountdownTimer) {
        clearInterval(this.codeCountdownTimer);
        this.codeCountdownTimer = null;
      }
    };
    tick();
    if (this.codeSecondsLeft > 0) {
      this.codeCountdownTimer = setInterval(tick, 1000);
    }
  }

  stopCodeCountdown(): void {
    if (this.codeCountdownTimer) {
      clearInterval(this.codeCountdownTimer);
      this.codeCountdownTimer = null;
    }
    this.codeExpiresAtMs = null;
    this.codeSecondsLeft = 0;
  }

  requestVerificationCodeForSelectedDest(): void {
    const agencyId = this.selectedIndex?._id || this.selectedIndex?.id;
    if (!agencyId || !this.selectedDestination?._id) return;

    this.requestingCode = true;
    this.hosAddendumService
      .requestDeliveryVerificationCode(agencyId, this.selectedDestination._id)
      .pipe(
        finalize(() => {
          this.requestingCode = false;
        }),
      )
      .subscribe({
        next: (res: any) => {
          this.messageHandlerService.generateToastMessage(
            "success",
            "Success",
            res?.message || "Verification code dispatched successfully",
          );
          this.requestCodeButtonLabel = "Resend Code";
          // Counted from when the code was sent, for as long as the server says it lasts.
          this.startCodeCountdown(Date.now() + (Number(res?.expiresInMinutes) || 30) * 60 * 1000);
          this.loadDeliveryDestinations(agencyId);
        },
        error: (err: any) => {
          this.messageHandlerService.generateToastMessage(
            "error",
            "Error",
            err?.error?.message || "Failed to request verification code",
          );
        },
      });
  }

  submitVerificationCode(): void {
    const agencyId = this.selectedIndex?._id || this.selectedIndex?.id;
    if (!agencyId || !this.selectedDestination?._id || !this.verificationCodeInput) return;

    this.verifyingCode = true;
    this.hosAddendumService
      .verifyDeliveryCode(agencyId, this.selectedDestination._id, this.verificationCodeInput.trim())
      .pipe(
        finalize(() => {
          this.verifyingCode = false;
        }),
      )
      .subscribe({
        next: (res: any) => {
          // A wrong code is a normal answer from the server (200, success: false), not an error. It was
          // announced as "verified successfully" and the popup closed on an address still unverified.
          if (res?.success === false) {
            this.messageHandlerService.generateToastMessage(
              "error",
              "Incorrect code",
              res?.message || "That code is not right. Please check it and try again.",
            );
            this.loadDeliveryDestinations(agencyId);
            return;
          }
          this.messageHandlerService.generateToastMessage(
            "success",
            "Success",
            "Destination verified successfully! Automated delivery is now available.",
          );
          this.stopCodeCountdown();
          this.verifyDestinationDialogVisible = false;
          // Shown at once: the verified address is now the only one on its channel, exactly as the
          // server leaves it, send switch included. The reload below confirms it.
          const verified = res?.destination;
          if (verified?.channel) {
            this.deliveryDestinations = [
              ...(this.deliveryDestinations || []).filter((d: any) => d.channel !== verified.channel),
              verified,
            ];
          }
          this.loadDeliveryDestinations(agencyId);
        },
        error: (err: any) => {
          this.messageHandlerService.generateToastMessage(
            "error",
            "Error",
            err?.error?.message || "Verification failed. Please check the code and try again.",
          );
          this.loadDeliveryDestinations(agencyId);
        },
      });
  }

  onToggleDeliveryDestination(dest: any): void {
    const agencyId = this.selectedIndex?._id || this.selectedIndex?.id;
    if (!agencyId || !dest?._id) return;

    this.togglingDestinationId = dest._id;
    this.hosAddendumService
      .toggleDeliveryDestination(agencyId, dest._id, dest.enabled)
      .pipe(
        finalize(() => {
          this.togglingDestinationId = null;
        }),
      )
      .subscribe({
        next: () => {
          this.messageHandlerService.generateToastMessage(
            "success",
            "Success",
            `Delivery destination ${dest.enabled ? "enabled" : "disabled"}`,
          );
        },
        error: (err: any) => {
          dest.enabled = !dest.enabled; // Revert toggle on error
          this.messageHandlerService.generateToastMessage(
            "error",
            "Error",
            err?.error?.message || "Failed to update destination status",
          );
        },
      });
  }
}
